import * as $ from 'jquery';
import {
  Component,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChange,
  Inject,
  Injector,
  ElementRef,
  forwardRef,
  Optional,
  EventEmitter,
  NgModule,
  ViewEncapsulation,
  ViewChild
} from '@angular/core';
import { RouterModule, NavigationStart, RoutesRecognized } from '@angular/router';
import { CommonModule } from '@angular/common';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

import 'rxjs/add/observable/from';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeAll';

import {
  InputConverter,
  ObservableWrapper,
  dataServiceFactory,
  OntimizeService,
  MomentService,
  Util,
  OFormComponent,
  OFormValue,
  OSharedModule,
  OServiceComponent,
  ODateInputModule,
  OFormModule
} from 'ontimize-web-ngx';

import { MdMenuTrigger, MdTabGroup, MdTab } from '@angular/material';

import { ODataTableCellEditorDateDialog } from './cell-editor/dialog/o-datatable-cell-editor-date-dialog.component';
import { ODataTableColumnComponent } from './o-datatable-column.component';
import {
  ODataTableCellEditorBooleanComponent,
  ODataTableCellEditorComboComponent,
  ODataTableCellEditorDateComponent,
  ODataTableCellEditorIntegerComponent,
  ODataTableCellEditorRealComponent,
  ODataTableCellEditorStringComponent
} from './cell-editor/cell-editor';

import {
  ODataTableCellRendererActionComponent,
  ODataTableCellRendererBooleanComponent,
  ODataTableCellRendererCurrencyComponent,
  ODataTableCellRendererDateComponent,
  ODataTableCellRendererImageComponent,
  ODataTableCellRendererIntegerComponent,
  ODataTableCellRendererRealComponent,
  ODataTableCellRendererServiceComponent,
  ODataTableCellRendererStringComponent
} from './cell-renderer/cell-renderer';

import {
  ODataTableButtonComponent,
  ODataTableOptionComponent,
} from './header-components/header-components';

import './o-datatable.loader';

const TABLE_CHECKBOX_TEMPLATE = `
  <div class="mat-checkbox-inner-container">
    <input class="mat-checkbox-input select-row" type="checkbox" name="id[]">
    <div class="mat-checkbox-ripple mat-ripple" md-ripple=""></div>
    <div class="mat-checkbox-frame"></div>
    <div class="mat-checkbox-background">
      <svg space="preserve" class="mat-checkbox-checkmark" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path class="mat-checkbox-checkmark-path" d="M4.1,12.7 9,17.6 20.3,6.3" fill="none" stroke="white"></path>
      </svg>
      <div class="mat-checkbox-mixedmark"></div>
    </div>
  </div>
`;

// import { OServiceComponent } from '../o-service-component.class';

export const DEFAULT_INPUTS_O_DATATABLE = [
  ...OServiceComponent.DEFAULT_INPUTS_O_SERVICE_COMPONENT,

  // insert-method [string]: name of the service method to perform inserts. Default: insert.
  'insertMethod: insert-method',

  // update-method [string]: name of the service method to perform updates. Default: update.
  'updateMethod: update-method',

  // visible-columns [string]: visible columns, separated by ';'. Default: no value.
  'visibleColumns: visible-columns',

  // editable-columns [string]: columns that can be edited directly over the table, separated by ';'. Default: no value.
  'editableColumns: editable-columns',

  // edit-on-focus [no|yes]: edit cell of an editable column when gaining the focus. Default: yes.
  'editOnFocus: edit-on-focus',

  // sort-columns [string]: initial sorting, with the format column:[ASC|DESC], separated by ';'. Default: no value.
  'sortColumns: sort-columns',

  // quick-filter [no|yes]: show quick filter. Default: yes.
  'quickFilter: quick-filter',

  // delete-button [no|yes]: show delete button. Default: no.
  'deleteButton: delete-button',

  // refresh-button [no|yes]: show refresh button. Default: yes.
  'refreshButton: refresh-button',

  // columns-visibility-button [no|yes]: show columns visibility button. Default: yes.
  'columnsVisibilityButton: columns-visibility-button',

  // columns-resize-button [no|yes]: show columns resize button. Default: yes.
  'columnsResizeButton: columns-resize-button',

  // columns-group-button [no|yes]: show columns group button. Default: yes.
  'columnsGroupButton: columns-group-button',

  // export-button [no|yes]: show export button. Default: yes.
  'exportButton: export-button',

  // insert-table [no|yes]: fix a row at the bottom that allows to insert new records. Default: no.
  'insertTable: insert-table',

  // edition-mode [inline || empty]: edition mode opened. Default none
  'editionMode: edition-mode',

  // show-table-buttons-text [string][yes|no|true|false]: show text of header buttons
  'showTableButtonsText: show-table-buttons-text',

  // select-all-checkbox [string][yes|no|true|false]:
  'selectAllCheckbox: select-all-checkbox',

  // pagination mode [string][yes|no|true|false]
  'singlePageMode : single-page-mode',

  // pagination-controls [string][yes|no|true|false]
  'paginationControls : pagination-controls',

  // filter-case-sensitive [string][yes|no|true|false] default:no
  'filterCaseSensitive : filter-case-sensitive'
];

export const DEFAULT_OUTPUTS_O_DATATABLE = [
  'onClick',
  'onRowSelected',
  'onRowDeselected',
  'onRowDeleted',
  'onDoubleClick',
  'onTableDataLoaded',
  'onPaginatedTableDataLoaded'
];

export interface ODataTableInitializationOptions {
  entity?: string;
  service?: string;
  columns?: string;
  visibleColumns?: string;
  keys?: string;
  sortColumns?: string;
  editableColumns?: string;
  parentKeys?: string;
}



export class ODataTableComponent extends OServiceComponent implements OnInit, OnDestroy, OnChanges {
  public static DEFAULT_INPUTS_O_DATATABLE = DEFAULT_INPUTS_O_DATATABLE;
  public static DEFAULT_OUTPUTS_O_DATATABLE = DEFAULT_INPUTS_O_DATATABLE;
  public static DEFAULT_DETAIL_ICON = 'search';

  public static COLUMNS_SEPARATOR = ';';
  public static COLUMNS_ALIAS_SEPARATOR = ':';
  public static OPTIONS_SEPARATOR = ';';
  public static VALUES_SEPARATOR = '=';
  public static TYPE_SEPARATOR = ':';
  public static TYPE_ASC_NAME = 'asc';
  public static TYPE_DESC_NAME = 'desc';
  public static DEFAULT_QUERY_ROWS_MENU = [
    [10, 25, 50, 100, -1],
    [10, 25, 50, 100, 'All']
  ];
  public static ROW_BUTTON_DETAIL = 'DETAIL';
  public static ROW_BUTTON_DELETE = 'DELETE';
  public static O_DATATABLE_OPTION_ACTIVE_CLASS = 'o-table-option-active';

  /* Inputs */
  protected insertMethod: string;
  protected updateMethod: string;
  protected visibleColumns: string;
  protected editableColumns: string;
  @InputConverter()
  editOnFocus: boolean = true;
  protected sortColumns: string;
  @InputConverter()
  quickFilter: boolean = true;
  @InputConverter()
  deleteButton: boolean = false;
  @InputConverter()
  refreshButton: boolean = true;
  @InputConverter()
  columnsVisibilityButton: boolean = true;
  @InputConverter()
  columnsResizeButton: boolean = true;
  @InputConverter()
  columnsGroupButton: boolean = true;
  @InputConverter()
  exportButton: boolean = true;
  @InputConverter()
  insertTable: boolean = false;
  editionMode: string;
  @InputConverter()
  showTableButtonsText: boolean = true;
  @InputConverter()
  selectAllCheckbox: boolean = false;
  @InputConverter()
  singlePageMode: boolean = false;
  @InputConverter()
  paginationControls: boolean = true;
  @InputConverter()
  filterCaseSensitive: boolean = false;
  /* End of Inputs */

  /*parsed inputs variables */
  protected visibleColumnsArray: Array<string>;
  protected editableColumnsArray: Array<string>;
  protected sortColumnsArray: Array<any>;
  protected dataParentKeys: Array<Object>;
  /* end of parsed inputs variables */

  protected initialized: boolean;
  protected momentService: MomentService;

  protected queryRowsMenu: Array<any>;
  protected editColumnIndex: number;
  protected detailColumnIndex: number;
  protected table: any;
  protected tableHtmlEl: any;
  protected dataTable: any;
  protected dataTableOptions: any;
  protected lastDeselection: any;
  protected groupColumnIndex: number;
  protected groupColumnOrder: string;
  protected onRouterNavigateSubscribe: any;
  protected onInsertRowFocusSubscribe: Array<any>;
  protected onInsertRowSubmitSubscribe: any;
  protected headerButtons: Array<ODataTableButtonComponent>;
  protected headerOptions: Array<ODataTableOptionComponent>;
  protected showOptionsButton: boolean = true;
  protected showExportOptions: boolean = false;

  protected mdTabGroupContainer: MdTabGroup;
  protected mdTabContainer: MdTab;
  protected mdTabGroupChangeSubscription: Subscription;

  protected pendingQuery: boolean = false;
  protected pendingQueryFilter = undefined;

  public onRowSelected: EventEmitter<any> = new EventEmitter();
  public onRowDeselected: EventEmitter<any> = new EventEmitter();
  public onRowDeleted: EventEmitter<any> = new EventEmitter();
  public onClick: EventEmitter<any> = new EventEmitter();
  public onDoubleClick: EventEmitter<any> = new EventEmitter();
  public onTableDataLoaded: EventEmitter<any> = new EventEmitter();
  public onPaginatedTableDataLoaded: EventEmitter<any> = new EventEmitter();

  protected storedRecordsIndexes: Array<any> = [];
  protected initialColumnsWidths: Array<any> = [];
  protected asyncLoadColumns: Array<any> = [];
  protected asyncLoadSubscriptions: Object = {};
  protected pendingOnLanguageChangeCallback: boolean = false;
  public parentItem: any;

   menuTrigger: MdMenuTrigger;
  private columnWidthHandlerInterval: any;

  private isProgrammaticSelection: boolean = false;
  private isProgrammaticChange: boolean = false;

  constructor(
    injector: Injector,
    elRef: ElementRef,
      form: OFormComponent
  ) {
    super(injector, elRef, form);

    try {
      this.mdTabGroupContainer = this.injector.get(MdTabGroup);
      this.mdTabContainer = this.injector.get(MdTab);
    } catch (error) {
      // Do nothing due to not always is contained on tab.
    }
    this.initialized = false;
    this.momentService = this.injector.get(MomentService);
    this.lastDeselection = undefined;
    this.groupColumnIndex = -1;
    this.groupColumnOrder = ODataTableComponent.TYPE_ASC_NAME;
    const showAllIndex = ODataTableComponent.DEFAULT_QUERY_ROWS_MENU[0].indexOf(-1);
    if (showAllIndex !== -1) {
      ODataTableComponent.DEFAULT_QUERY_ROWS_MENU[1][showAllIndex] = this.translateService.get('TABLE.SHOW_ALL');
    }
    this.headerButtons = [];
    this.headerOptions = [];

    this.onRouterNavigateSubscribe = this.router.events.subscribe(route => {
      if ((typeof (this.oattr) === 'undefined') ||
        !(route instanceof NavigationStart || route instanceof RoutesRecognized) ||
        ((route instanceof NavigationStart || route instanceof RoutesRecognized) && (!route.url.startsWith(this.router.url)))) {
        let localStorageState = localStorage.getItem('DataTables' + '_' + this.oattr + '_' + this.router.url);
        if (localStorageState) {
          let state = JSON.parse(localStorageState);
          delete state.start;
          delete state.selectedIndex;
          localStorage.setItem('DataTables' + '_' + this.oattr + '_' + this.router.url, JSON.stringify(state));
        }
      }
    });

    this.onInsertRowFocusSubscribe = [];
    this.onInsertRowSubmitSubscribe = undefined;
  }

  onLanguageChangeCallback(res: any) {
    if (this.mdTabContainer === undefined || this.mdTabContainer.content.isAttached) {
      this.reinitializeTable();
      if (this.queryOnBind) {
        this.queryData(this.parentItem);
      }
    } else if (this.mdTabContainer !== undefined) {
      this.pendingOnLanguageChangeCallback = true;
    }
  }

  getComponentKey(): string {
    return 'DataTables_' + this.oattr;
  }

  protected setTableInitialState() {
    this.dataArray = [];
    this.storedRecordsIndexes = [];
  }

  protected reinitializeTable() {
    this.isProgrammaticChange = true;
    if (this.dataTable) {
      this.dataTable.fnDestroy();
      $(this.tableHtmlEl).children().remove();
    }
    this.dataTable = null;
    this.state.queryRecordOffset = 0;
    if (this.dataTableOptions) {
      this.setTableInitialState();
      this.initTableOnInit(this.dataTableOptions.columns);
      this.initTableAfterViewInit();
      if ((typeof (this.table) !== 'undefined') && (this.sortColumnsArray.length > 0)) {
        this.table.order(this.sortColumnsArray);
        this.table.draw();
      }
    }
    this.isProgrammaticChange = false;
  }

  ngOnInit(): void {
    this.initialize();
    this.extendDataTablesSortMethods();
  }

  getNumberComparisionValues(x: any, y: any, valueAttr: string): any {
    let result = [];
    if ((x.indexOf(valueAttr) !== -1) && (y.indexOf(valueAttr) !== -1)) {
      let tmpx = x.substr(x.indexOf(valueAttr) + valueAttr.length + 2);
      tmpx = tmpx.substr(0, tmpx.indexOf('"'));
      result.push(parseFloat(tmpx));

      let tmpy = y.substr(y.indexOf(valueAttr) + valueAttr.length + 2);
      tmpy = tmpy.substr(0, tmpy.indexOf('"'));
      result.push(parseFloat(tmpy));
    }
    return result;
  }

  compareNumeric(x: any, y: any, valueAttr: string, asc: boolean) {
    const [xV, yV] = this.getNumberComparisionValues(x, y, valueAttr);
    let diff = 0;
    if (xV !== undefined && yV !== undefined) {
      diff = xV - yV;
    } else {
      diff = x - y;
    }
    if (diff === 0) {
      return 0;
    }
    if (asc) {
      return (diff < 0) ? -1 : 1;
    } else {
      return (diff < 0) ? 1 : -1;
    }
  }

  extendDataTablesSortMethods() {
    const self = this;

    ($ as any).fn.dataTable.ext.type.order['string-pre'] = function (a) {
      if (!a) {
        return '';
      }
      let val = typeof a === 'string' ? a.toLowerCase() : !a.toString ? '' : a.toString();
      val = val.trim();
      return val;
    };

    let sortMethods = ((($ as any).fn.dataTableExt.oSort) as any);
    if (!sortMethods.hasOwnProperty('o-number-asc')) {
      sortMethods['o-number-asc'] = function (x, y) {
        return self.compareNumeric(x, y, 'o-number-value', true);
      };
    }

    if (!sortMethods.hasOwnProperty('o-number-desc')) {
      sortMethods['o-number-desc'] = function (x, y) {
        return self.compareNumeric(x, y, 'o-number-value', false);
      };
    }

    if (!sortMethods.hasOwnProperty('o-timestamp-asc')) {
      sortMethods['o-timestamp-asc'] = function (x, y) {
        return self.compareNumeric(x, y, 'o-timestamp-value', true);
      };
    }

    if (!sortMethods.hasOwnProperty('o-timestamp-desc')) {
      sortMethods['o-timestamp-desc'] = function (x, y) {
        return self.compareNumeric(x, y, 'o-timestamp-value', false);
      };
    }
  }

  reinitialize(options: ODataTableInitializationOptions) {
    super.reinitialize(options);
    this.editColumnIndex = undefined;
    this.detailColumnIndex = undefined;

    if (options && Object.keys(options).length) {
      if (this.table) {
        this.table.destroy();
        this.dataTable.children().remove();
      }
      this.reinitializeTable();
    }
  }

  initialize(): any {

    if (!this.detailButtonInRowIcon) {
      this.detailButtonInRowIcon = ODataTableComponent.DEFAULT_DETAIL_ICON;
    }

    super.initialize();

    this.dataParentKeys = [];
    if (this.parentKeys) {
      let keys = Util.parseArray(this.parentKeys);
      for (let i = 0; i < keys.length; ++i) {
        let key = keys[i];
        let keyDef = key.split(ODataTableComponent.COLUMNS_ALIAS_SEPARATOR);
        if (keyDef.length === 1) {
          this.dataParentKeys.push({
            'alias': keyDef[0],
            'name': keyDef[0]
          });
        } else if (keyDef.length === 2) {
          this.dataParentKeys.push({
            'alias': keyDef[0],
            'name': keyDef[1]
          });
        }
      }
    }
    this.queryRowsMenu = [];
    this.queryRowsMenu[0] = ODataTableComponent.DEFAULT_QUERY_ROWS_MENU[0].slice();
    this.queryRowsMenu[1] = ODataTableComponent.DEFAULT_QUERY_ROWS_MENU[1].slice();
    if (this.queryRowsMenu[0].indexOf(this.queryRows) === -1) {
      for (let i = 0; i < this.queryRowsMenu[0].length; i++) {
        var item = this.queryRowsMenu[0][i];
        if (item > this.queryRows || item === -1) {
          this.queryRowsMenu[0].splice(i, 0, this.queryRows);
          this.queryRowsMenu[1].splice(i, 0, this.queryRows);
          break;
        }
      }
    }

    // get previous position
    let localStorageState = localStorage.getItem('DataTables' + '_' + this.oattr + '_' + this.router.url);
    if (localStorageState) {
      this.state = JSON.parse(localStorageState);
    } else {
      this.state = {};
    }

    this.visibleColumnsArray = Util.parseArray(this.visibleColumns);
    this.editableColumnsArray = Util.parseArray(this.editableColumns);

    //TODO: get default values from ICrudConstants
    if (!this.insertMethod) {
      this.insertMethod = 'insert';
    }
    if (!this.updateMethod) {
      this.updateMethod = 'update';
    }

    if (this.insertButton === undefined) {
      this.insertButton = true;
    }

    if (this.mdTabGroupContainer && this.mdTabContainer) {
      /*
      * When table is contained into tab component, it is necessary to init
      * table component when attached to DOM.
      */
      var self = this;
      this.mdTabGroupChangeSubscription = this.mdTabGroupContainer.selectChange.subscribe((evt) => {
        var interval = setInterval(function () { timerCallback(evt.tab); }, 100);
        function timerCallback(tab: MdTab) {
          if (tab && tab.content.isAttached) {
            clearInterval(interval);
            if (tab === self.mdTabContainer) {
              if (self.table && self.pendingOnLanguageChangeCallback) {
                self.pendingOnLanguageChangeCallback = false;
                self.table.destroy();
                self.dataTable.children().remove();
                self.reinitializeTable();
                if (self.queryOnBind) {
                  self.queryData(self.parentItem);
                }
              } else if (self.table === undefined) {
                self.reinitializeTable();
              }
              if (self.pendingQuery) {
                self.queryData(self.pendingQueryFilter);
              }
            }
          }
        }
      });
    }
    this.initTableOnInit();
  }

  ngOnDestroy() {
    this.destroy();
  }

  destroy() {
    super.destroy();
    if (this.mdTabGroupChangeSubscription) {
      this.mdTabGroupChangeSubscription.unsubscribe();
    }
    this.onRouterNavigateSubscribe.unsubscribe();
    for (let i = 0; i < this.onInsertRowFocusSubscribe.length; ++i) {
      this.onInsertRowFocusSubscribe[i].unsubscribe();
    }
    if (typeof (this.onInsertRowSubmitSubscribe) !== 'undefined') {
      this.onInsertRowSubmitSubscribe.unsubscribe();
    }
    Object.keys(this.asyncLoadSubscriptions).forEach(idx => {
      if (this.asyncLoadSubscriptions[idx]) {
        this.asyncLoadSubscriptions[idx].unsubscribe();
      }
    });
  }

  public ngAfterViewInit() {
    if (this.mdTabContainer === undefined
      || this.mdTabContainer.content.isAttached) {
      this.initTableAfterViewInit();
    }
    if (this.menuTrigger) {
      this.menuTrigger.onMenuOpen.subscribe(args => this.onOptionsMenuShow(args));
    }
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if ((typeof (changes['staticData']) !== 'undefined') && (typeof (this.dataTable) !== 'undefined')) {
      this.dataTable.fnClearTable(false);
      this.dataArray = changes['staticData'].currentValue;
      if (this.dataArray.length > 0) {
        this.dataTable.fnAddData(this.dataArray);
      }
      this.dataTable.fnDraw();
    }
  }

  /**
   *@deprecated
   */
  public refresh() {
    this.reloadData();
  }

  public reloadData() {
    let newOffset = Math.max(this.state.queryRecordOffset - this.queryRows, 0);
    let queryArgs = {
      offset: newOffset,
      length: this.queryRows,
      resultRecordsIndex: newOffset,
      replace: true
    };
    let endIndex = queryArgs.offset + queryArgs.length;

    for (var i = this.storedRecordsIndexes.length - 1; i >= 0; i--) {
      var storedStart = this.storedRecordsIndexes[i].start;
      var storedEnd = this.storedRecordsIndexes[i].end;

      if ((storedStart === queryArgs.offset) && (storedEnd === endIndex)) {
        this.storedRecordsIndexes.splice(i, 1);
        break;
      }
    }
    this.queryData(this.parentItem, queryArgs);
  }

  protected initTableOnInit(columns: any = undefined) {
    var self = this;

    let domOption = 'r<"dataTables_fill_remaining"<"o-table-scroll"t>>';
    if (this.paginationControls) {
      domOption += '<"dataTables_pagination_wrapper"pil>';
    }
    if (this.controls) {
      domOption = '<"dataTables_top_wrapper"B<"dataTables_filter_wrapper"<"dataTables_hidden_options">f><"dataTables_options">>' + domOption;
    }

    this.dataTableOptions = {
      data: this.dataArray,
      /*dom attribute
      B: buttons
      f: {filter}
      r: {processing}
      t: {table}
      p: {pagination}
      i: {information}
      l: {length}
      */
      // dom: '<"dataTables_top_wrapper"B<"dataTables_filter_wrapper"<"dataTables_hidden_options">f><"dataTables_options">>rtpil',
      dom: domOption,
      buttons: this.getTableButtons(),
      select: !this.selectAllCheckbox,
      autoWidth: false,
      stateSave: true,
      filter: this.quickFilter,
      ordering: true,
      info: true,
      paging: true,
      pageLength: this.queryRows,
      lengthMenu: this.queryRowsMenu,
      pagingType: 'full', // simple, simple_numbers, full, full_numbers,
      colResize: {
        tableWidthFixed: false
      },
      language: this.getLanguageLabels(),
      keys: true,
      columns: [],
      search: {
        bCaseInsensitive: !this.filterCaseSensitive
      },
      createdRow: (row, data, dataIndex) => {
        let tr = $(row) as any;
        tr.children().each(function (i, e) {
          let td = $(e) as any;
          const hasChildren = (td.children().length > 0);
          if (hasChildren) {
            const children = td.children();
            if (typeof (children.attr('o-timestamp-value')) !== 'undefined') {
              td.attr('o-timestamp-value', children.attr('o-timestamp-value'));
              td.html(td.children().text());
            }
            if (typeof (children.attr('o-number-value')) !== 'undefined') {
              td.attr('o-number-value', children.attr('o-number-value'));
              td.html(td.children().text());
            }
          }
        });
      },
      initComplete: (settings) => {
        this.handleColumnWidth(settings);
        let controlButtons = $('#' + this.oattr + '_wrapper .generic-action') as any;
        ($ as any).each(controlButtons, function (i, el) {
          ($(this) as any).attr('title', ($(this) as any).find('span').text());
        });

        let customButtons = $('#' + this.oattr + '_wrapper .custom-generic-action') as any;
        ($ as any).each(customButtons, function (i, el) {
          var btnEl = ($(this) as any);
          var iconMatch = btnEl.attr('class').match(/icon-(.*)/);
          var icon = '';
          if (iconMatch !== null) {
            icon = iconMatch[1];
          }
          btnEl.attr('data-icon', icon);
          btnEl.attr('title', ($(this) as any).find('span').text());
        });

        let filterButton = $('#' + this.oattr + '_wrapper .generic-action-filter') as any;
        let filterInput = ($('#' + this.oattr + '_filter') as any).find('input');
        if ((filterInput.length > 0) && (filterInput.val().length > 0)) {
          filterButton.addClass('filtering');
        } else {
          filterButton.removeClass('filtering');
        }
        filterInput.keyup(function () {
          if (filterInput.val().length > 0) {
            filterButton.addClass('filtering');
          } else {
            filterButton.removeClass('filtering');
          }
        });
      },
      drawCallback: (settings) => {
        if (self.groupColumnIndex >= 0) {
          let api = this.dataTable.api();
          let rows = api.rows({ page: 'current' }).nodes();
          let last = null;
          api.column(this.groupColumnIndex, { page: 'current' }).data().each((group, i) => {
            if (last !== group) {
              ($(rows) as any).eq(i).before(
                '<tr class="group"><td colspan="100%">' +
                this.dataTableOptions.columns[this.groupColumnIndex].component.render(group) +
                '</td></tr>'
              );
              last = group;
            }
          });
        }
        if (self.insertTable && self.oenabled) {
          for (let i = 0; i < this.onInsertRowFocusSubscribe.length; ++i) {
            this.onInsertRowFocusSubscribe[i].unsubscribe();
          }
          this.onInsertRowFocusSubscribe = [];
          if (typeof (this.onInsertRowSubmitSubscribe) !== 'undefined') {
            this.onInsertRowSubmitSubscribe.unsubscribe();
            this.onInsertRowSubmitSubscribe = undefined;
          }

          let tbody = $('#' + this.oattr + '_wrapper table tbody') as any;
          tbody.append('<tr class="insertRow"></tr>');
          var insertRow = tbody.find('.insertRow');
          let lastEditor = true;
          for (let i = settings.aoColumns.length - 1; i >= 0; --i) {
            let colDef = settings.aoColumns[i];
            if (colDef.bVisible) {
              let tdClass = (i === 0 && this.selectAllCheckbox) ? 'o-table-column-select-checkbox' : 'o-table-column-insert-table';
              insertRow.prepend('<td class=' + tdClass + '></td>');
              if (colDef.editable && (typeof (colDef.component) !== 'undefined') &&
                (typeof (colDef.component.editor) !== 'undefined')) {
                let insertCell = insertRow.find('td:first');
                colDef.component.editor.createEditorForInsertTable(insertCell, undefined);
                this.onInsertRowFocusSubscribe.push(
                  colDef.component.editor.onFocus.subscribe(
                    res => {
                      if (res.insertTable) {
                        this.table.rows().deselect();
                        this.table.cell.blur();
                      }
                    }
                  )
                );
                if (lastEditor && this.dataService && (this.insertMethod in this.dataService) && this.entity) {
                  this.onInsertRowSubmitSubscribe = colDef.component.editor.onSubmit.subscribe(
                    res => {
                      if (res.insertTable) {
                        let av = this.getAvToInsertFromTableSettings(settings, true);
                        // perform insert
                        console.log('[ODataTable.rowSubmit]: insert', av);
                        this.loaderSuscription = this.load();
                        this.dataService[this.insertMethod](av, this.entity)
                          .subscribe(
                          res => {
                            if ((typeof (res.code) === 'undefined') ||
                              ((typeof (res.code) !== 'undefined') && (res.code === 0))) {
                              this.queryData(this.parentItem);
                              console.log('[ODataTable.rowSubmit]: insert ok', res);
                            } else {
                              console.log('[ODataTable.rowSubmit]: error', res.code);
                              this.dialogService.alert('ERROR', 'MESSAGES.ERROR_INSERT');
                            }
                            this.loaderSuscription.unsubscribe();
                          },
                          err => {
                            console.log('[ODataTable.rowSubmit]: error', err);
                            this.loaderSuscription.unsubscribe();
                            this.postIncorrectInsert(err);
                          }
                          );

                      }
                    }
                  );
                  lastEditor = false;
                } else if (lastEditor && this.staticData) {
                  this.onInsertRowSubmitSubscribe = colDef.component.editor.onSubmit.subscribe(
                    res => {
                      if (res.insertTable) {
                        let av = this.getAvToInsertFromTableSettings(settings, false);
                        this.staticData.push(av);
                        this.setDataArray(this.staticData);
                        if (typeof (this.dataTable) !== 'undefined') {
                          this.dataTable.fnClearTable(false);
                          if (this.dataArray.length > 0) {
                            this.dataTable.fnAddData(this.dataArray);
                          }
                          this.dataTable.fnDraw();
                        }
                      }
                    });
                  lastEditor = false;
                }
              }
            }
          }
        }
        let emptyRow = $('.dataTables_empty') as any;
        if (emptyRow.length > 0) {
          emptyRow.parent().addClass('empty');
        }
        if (self.pageable && self.dataArray && self.dataArray.length) {
          self.updatePageableTable(!settings._drawHold);
        }
        if (self.asyncLoadColumns.length && self.table) {
          self.table.rows({ page: 'current' }).indexes().each(function (index) {
            self.queryRowAsyncData(self.table.row(index).data(), index);
          });
        }
      },
      headerCallback: function (thead, data, start, end, display) {
        if (self.selectAllCheckbox) {
          var checkboxCell = ($(thead) as any).find('th').eq(0);
          checkboxCell.attr('class', 'o-table-column-select-checkbox');
          checkboxCell.html(TABLE_CHECKBOX_TEMPLATE);
          checkboxCell.find('.select-row').attr('id', 'select_all');
        }
      }
    };

    if (typeof (columns) !== 'undefined') {
      // columns defined with 'o-table-column' directives
      for (let i = 0; i < columns.length; ++i) {
        let col = columns[i];
        if ((typeof (col.title) === 'string') && (col.name === col.data)) {
          // little trick to translate titles whose translation had not been loaded at initialization time
          col.title = this.translateService.get(col.name);
          col.sTitle = col.title;
        }
        // else if (col.selectAllColumn) {
        //   //workaround for selectAllCheckbox
        //   columns[i] = {
        //     selectAllColumn: true,
        //     searchable: false,
        //     orderable: false,
        //     className: 'o-table-column-select-checkbox',
        //     render: function (data, type, full, meta) {
        //       return TABLE_CHECKBOX_TEMPLATE;
        //     }
        //   };
        // }
      }
      this.dataTableOptions.columns = columns;
    } else {
      if (this.selectAllCheckbox) {
        this.dataTableOptions.columns.push({
          selectAllColumn: true,
          searchable: false,
          orderable: false,
          className: 'o-table-column-select-checkbox',
          render: function (data, type, full, meta) {
            return TABLE_CHECKBOX_TEMPLATE;
          }
        });
      }
      // columns defined only with the 'visible-columns' attribute
      for (let i = 0; i < this.visibleColumnsArray.length; ++i) {
        let col = this.visibleColumnsArray[i];
        let colDef = {
          data: col,
          name: col,
          title: this.translateService.get(col),
          className: 'o-table-column',
          defaultContent: '',
          orderable: true,
          searchable: true,
          editable: (this.editableColumnsArray.indexOf(col) !== -1),
          visible: (this.visibleColumnsArray.indexOf(col) !== -1)
        };
        if (this.editOnFocus && colDef.editable) {
          colDef.className += ' editable ';
        }
        this.dataTableOptions.columns.push(colDef);
      }
    }

    this.sortColumnsArray = [];
    if (this.sortColumns) {
      let cols = Util.parseArray(this.sortColumns);
      for (let i = 0; i < cols.length; ++i) {
        let col = cols[i];
        let colDef = col.split(ODataTableComponent.TYPE_SEPARATOR);
        if (colDef.length > 0) {
          let colName = colDef[0];
          for (let colIndex = 0; colIndex < this.dataTableOptions.columns.length; ++colIndex) {
            if (colName === this.dataTableOptions.columns[colIndex].name) {
              let sortDirection = ODataTableComponent.TYPE_ASC_NAME;
              if (colDef.length > 1) {
                sortDirection = colDef[1].toLowerCase();
                switch (sortDirection) {
                  case ODataTableComponent.TYPE_DESC_NAME:
                    sortDirection = ODataTableComponent.TYPE_DESC_NAME;
                    break;
                }
              }
              this.sortColumnsArray.push([colIndex, sortDirection]);
            }
          }
        }
      }
      // (typeof (columns) !== 'undefined')
      if (this.sortColumnsArray.length > 0) {
        this.dataTableOptions.order = this.sortColumnsArray;
      }
    }
  }


  getColumsNumber(): number {
    return this.dataTableOptions.columns.length;
  }

  protected addDefaultRowButtons() {
    this.editColumnIndex = -1;
    this.detailColumnIndex = -1;

    if (this.editButtonInRow) {
      var editColumn = new ODataTableColumnComponent(this, this.injector);
      var editColumnRenderer = new ODataTableCellRendererActionComponent(editColumn, this.injector);
      editColumnRenderer.init({
        action: 'edit',
        editionMode: this.editionMode,
        renderType: 'icon',
        renderValue: this.editButtonInRowIcon
      });
      this.editColumnIndex = this.dataTableOptions.columns.length;
      this.registerColumn(editColumn);
    }
    if (this.detailButtonInRow) {
      var detailColumn = new ODataTableColumnComponent(this, this.injector);
      var detailColumnRenderer = new ODataTableCellRendererActionComponent(detailColumn, this.injector);
      detailColumnRenderer.init({
        action: 'detail',
        renderType: 'icon',
        renderValue: this.detailButtonInRowIcon
      });
      this.detailColumnIndex = this.dataTableOptions.columns.length;
      this.registerColumn(detailColumn);
    }
  }

  protected onOptionsMenuShow(args: any) {
    var menuEl = ($('.mat-overlay-container .mat-menu') as any);
    var menuContainer = menuEl.parent();
    if (menuContainer) {
      var menuBtn = ($(this.elRef.nativeElement) as any).find('.o-table-menu-button');
      var menuBtnOffset = menuBtn.offset();
      var top = menuBtnOffset.top + menuBtn.outerHeight(true) - 30;
      var left = menuBtnOffset.left - menuEl.outerWidth(true) + menuBtn.outerWidth(true) - 16;
      menuContainer.css('transform', 'translateX(' + left + 'px) translateY(' + top + 'px)');
    }
  }

  protected parseTableOptions() {
    let tableOptions = [];
    if (this.controls) {
      tableOptions = this.getTableOptions();
      if (tableOptions.length > 0) {
        var table = this.table;
        const btns = new ($ as any).fn.dataTable.Buttons(table, {
          buttons: tableOptions
        });
        table.buttons(1, null).container().appendTo(
          ($(table.table().container()) as any).find('.dataTables_top_wrapper .dataTables_hidden_options')
        );
      }
    }
    this.showOptionsButton = (tableOptions.length > 0 || this.headerOptions.length > 0);
  }

  protected initTableAfterViewInit() {
    this.tableHtmlEl = $('#' + this.oattr) as any;
    if ((this.tableHtmlEl.length > 0) && (this.tableHtmlEl[0].tagName !== 'TABLE')) {
      this.tableHtmlEl = this.tableHtmlEl.find('table');
    }

    if ((typeof (this.editColumnIndex) === 'undefined') && (typeof (this.detailColumnIndex) === 'undefined')) {
      this.addDefaultRowButtons();
    }
    this.table = this.tableHtmlEl.DataTable(this.dataTableOptions);
    const fxdHeader = new ($ as any).fn.dataTable.FixedHeader(this.table, {
      header: true,
      forceFloating: true,
      scrollWidth: 20
    });
    this.parseTableOptions();

    if (typeof (this.state.length) === 'number') {
      this.queryRows = this.state.length;
      if (this.queryRows === -1) {
        this.queryRows = this.state.queryTotalRecordNumber ? this.state.queryTotalRecordNumber : OServiceComponent.DEFAULT_QUERY_ROWS;
      }
    }
    this.isProgrammaticChange = true;
    this.table.page.len(this.queryRows).draw(false);
    this.isProgrammaticChange = false;

    let startRecordValue = 0;
    if (typeof (this.state.start) === 'number') {
      startRecordValue = this.state.start;
    }
    this.state.queryRecordOffset = startRecordValue;

    if (!this.selectAllCheckbox) {

      this.table.off('select').on('select', (event: any, dt: Array<any>, type: string, indexes: Array<any>) => {
        if (this.oenabled) {
          if (typeof (indexes) !== 'undefined') {
            event.preventDefault();
            event.stopPropagation();
            this.handleSelection(event, dt, type, indexes);
          }
        }
      });

      this.table.off('deselect').on('deselect', (event: any, dt: Array<any>, type: string, indexes: Array<any>) => {
        if (this.oenabled) {
          if (typeof (indexes) !== 'undefined') {
            event.preventDefault();
            event.stopPropagation();
            this.handleDeselection(event, dt, type, indexes);
          }
        }
      });

    }

    this.table.off('key').on('key', (event, dt, key, cell, originalEvent) => {
      if (this.oenabled) {
        let colIndex = cell.index()['column'];
        let colDef = this.table.settings().init().columns[colIndex];
        let colType = colDef.type;
        if (typeof (colDef.component) !== 'undefined') {
          colType = colDef.component.type;
        }
      }
    });

    this.table.off('key-focus').on('key-focus', (event, dt, cell) => {
      if (this.oenabled) {
        // select row
        if (!this.selectAllCheckbox) {
          let indexes = [cell.index()['row']];
          this.table.rows(indexes).select();
        }
        // if cell is editable, create editor
        let cellEl = $(cell.nodes()) as any;
        let colIndex = cell.index()['column'];
        let colDef = this.table.settings().init().columns[colIndex];
        if (this.editOnFocus && colDef.editable && (typeof (colDef.component) !== 'undefined') &&
          (typeof (colDef.component.editor) !== 'undefined')) {
          if (cellEl.hasClass('editable')) {
            colDef.component.editor.handleCellFocus(cellEl, cell.data());
          } else {
            cellEl.removeClass('focus');
          }
        } else if (!this.editOnFocus) {
          cellEl.removeClass('focus');
        }
      }
    });
    this.table.off('key-blur').on('key-blur', (event, dt, cell) => {
      if (this.oenabled) {
        // if cell is editable, perform insertion
        let colIndex = cell.index()['column'];
        let colDef = this.table.settings().init().columns[colIndex];
        if (this.editOnFocus && colDef.editable && (typeof (colDef.component) !== 'undefined') &&
          (typeof (colDef.component.editor) !== 'undefined')) {
          let cellEl = $(cell.nodes()) as any;
          if (cellEl.hasClass('editable')) {
            colDef.component.editor.handleCellBlur(cellEl);
          } else {
            cellEl.removeClass('focus');
          }
        }
      }
    });
    var self = this;
    this.table.off('draw.dt').on('draw.dt', () => {
      self.tableHtmlEl.find('tr').off('click').on('click', (event: any) => this.handleClick(event));
      self.tableHtmlEl.find('tr').off('dblclick').on('dblclick', (event: any) => this.handleDoubleClick(event));
      if (this.selectAllCheckbox) {
        self.tableHtmlEl.find('th #select_all').off('click').on('click', (event: any) => this.handleSelectAllClick(event));
        self.tableHtmlEl.find('tbody tr .select-row').off('change').on('change', (event: any) => this.handleRowCheckboxChange(event));
      }
    });

    this.table.on('order.dt', () => {
      if (self.isProgrammaticChange) {
        return;
      }
      let order = this.table.order();
      if ((this.groupColumnIndex !== -1) && (order[0][0] !== this.groupColumnIndex)) {
        order.unshift([this.groupColumnIndex, this.groupColumnOrder]);
        this.table.order(order);
        this.dataTable.fnDraw();
      }
      this.handleOrderIndex();
      let emptyRow = $('.dataTables_empty') as any;
      if (emptyRow.length > 0) {
        emptyRow.parent().addClass('empty');
      }
    });
    this.table.off('column-visibility.dt').on('column-visibility.dt', (e, settings, column, state) => {
      if (self.isProgrammaticChange) {
        return;
      }
      const dialogBtn = $('.dt-button-collection > .dt-button.buttons-columnVisibility:nth-child(' + (column + 1) + ')');
      if (state) {
        dialogBtn.addClass('active');
      } else {
        dialogBtn.removeClass('active');
      }

      this.handleColumnWidth(settings);
      this.handleOrderIndex();
      let resizeButton = $('#' + this.oattr + '_wrapper .generic-action-resize') as any;
      if (resizeButton.hasClass('active')) {
        this.initColumnResize();
      }
      this.initColumnGroup();
    });

    this.table.off('length.dt').on('length.dt', (e, settings, len) => {
      if (self.isProgrammaticChange) {
        return;
      }
      setTimeout(() => {
        let resizeButton = $('#' + self.oattr + '_wrapper .generic-action-resize') as any;
        if (resizeButton.hasClass('active')) {
          self.initColumnResize();
        }
        if (self.pageable && self.dataArray && self.dataArray.length > 0) {
          let newFirstPageRecord = Math.floor((self.state.queryRecordOffset - self.queryRows) / len) * len;

          self.setTableInitialState();

          self.queryRows = (len !== -1) ? len : (self.state.queryTotalRecordNumber || -1);

          let queryArgs = {
            offset: newFirstPageRecord,
            length: self.queryRows
          };
          self.queryData(this.parentItem, queryArgs);
        }
      }, 100);
    });

    this.table.off('search.dt').on('search.dt', () => {
      if (self.isProgrammaticChange) {
        return;
      }
      setTimeout(() => {
        let resizeButton = $('#' + this.oattr + '_wrapper .generic-action-resize') as any;
        if (resizeButton.hasClass('active')) {
          this.initColumnResize();
        }
      }, 100);
    });

    this.initColumnGroup();
    this.dataTable = this.tableHtmlEl.dataTable();
    this.initialized = true;

    if (this.staticData) {
      this.setDataArray(this.staticData);
    } else if (this.queryOnInit) {
      this.queryData(this.parentItem);
    }
  }

  public setInitialColumnWidth(column: ODataTableColumnComponent) {
    // let existing: any = this.initialColumnsWidths.filter(
    //   element => element.name === column.getColumnName());
    // if (existing) {
    //   existing.width = column.width;
    // } else {
    this.initialColumnsWidths.push({
      name: column.getColumnName(),
      width: column.width
    });
    // }
  }

  public registerColumn(column: ODataTableColumnComponent, index?: number) {
    let colDef = {
      data: undefined,
      name: undefined,
      component: column,
      title: this.translateService.get(column.title),
      type: 'string',
      className: 'o-table-column ' + (column.class || '') + ' ',
      defaultContent: '',
      orderable: true,
      searchable: true,
      editable: false,
      visible: true,
      render: (data: any, type: string, item: Object, meta: Object) => column.render(data, item),
      createdCell: (cellElement: any, cellData: any, item: Object, rowIndex: number, colIndex: number) =>
        column.handleCreatedCell($(cellElement) as any, item)
    };
    if (column.width) {
      this.setInitialColumnWidth(column);
    }

    if (typeof (column.attr) === 'undefined') {
      // column without 'attr' should contain only renderers that do not depend on cell data, but row data (e.g. actions)
      colDef.className += ' o-table-column-action ';
      colDef.orderable = false;
      colDef.searchable = false;
      colDef.name = column.generatedAttr;
    } else {
      // columns with 'attr' are linked to service data
      colDef.data = column.attr;
      colDef.name = column.attr;
      this.setColumnDefTypeAttributes(colDef, column.type);
      colDef.orderable = column.orderable;
      colDef.searchable = column.searchable;
      colDef.editable = column.editable;
      if (this.editOnFocus && colDef.editable) {
        colDef.className += ' editable ';
      }
      colDef.visible = (this.visibleColumnsArray.indexOf(column.attr) !== -1);
      if (column.asyncLoad) {
        this.asyncLoadColumns.push(column.attr);
      }
    }
    //find column definition by name
    if (typeof (column.attr) !== 'undefined') {
      // adding to dataColums for using it in service queries
      if (this.colArray.indexOf(column.attr) === -1) {
        this.colArray.push(column.attr);
      }
      var alreadyExisting = this.dataTableOptions.columns.filter(function (existingColumn) {
        return existingColumn.name === column.attr;
      });
      if (alreadyExisting.length === 1) {
        var replacingIndex = this.dataTableOptions.columns.indexOf(alreadyExisting[0]);
        this.dataTableOptions.columns[replacingIndex] = colDef;
      } else if (alreadyExisting.length === 0) {
        this.dataTableOptions.columns.push(colDef);
      }
    } else {
      this.dataTableOptions.columns.push(colDef);
    }
  }

  protected setColumnDefTypeAttributes(colDef: any, type: string) {
    switch (type) {
      case 'boolean':
        colDef.className += ' o-table-column-boolean ';
        colDef.type = 'string';
        break;
      case 'string':
        colDef.className += ' o-table-column-string ';
        colDef.type = 'string';
        break;
      case 'integer':
      case 'real':
      case 'currency':
        colDef.className += ' o-table-column-number ';
        colDef.type = 'o-number';
        break;
      case 'date':
        colDef.className += ' o-table-column-date ';
        colDef.type = 'o-timestamp';
        break;
      case 'image':
        colDef.className += ' o-table-column-image ';
        colDef.type = 'string';
        break;
      default:
        colDef.className += ' o-table-column-string ';
        colDef.type = 'string';
        break;
    }
  }

  public updateDataTableOptions(columnAttr: string, type: string) {
    if (type !== undefined && this.dataTableOptions !== undefined && this.dataTableOptions.columns !== undefined) {
      let columns = this.dataTableOptions.columns;
      for (let i = 0, len = columns.length; i < len; i++) {
        if (columns[i].data === columnAttr) {
          this.setColumnDefTypeAttributes(columns[i], type);
          break;
        }
      }
    }
  }

  public updateCell(cellElement: any, value: any, sqltypes?: any) {
    let cell = this.table.cell(cellElement);
    if ((value !== cell.data()) && this.dataService && (this.updateMethod in this.dataService) && this.entity &&
      (this.keysArray.length > 0)) {
      var oldValue = cell.data();
      // persist update
      let colIndex = cell.index()['column'];
      let colDef = this.table.settings().init().columns[colIndex];
      let indexes = [cell.index()['row']];
      let rowDataArray = this.table.rows(indexes).data().toArray();
      if (rowDataArray.length === 1) {
        let rowData = rowDataArray[0];
        console.log('[ODataTable.updateCell]: before update', rowData);
        let kv = {};
        for (let k = 0; k < this.keysArray.length; ++k) {
          let key = this.keysArray[k];
          kv[key] = rowData[key];
        }
        let av = {};
        av[colDef.name] = value;
        this.loaderSuscription = this.load();
        this.dataService[this.updateMethod](kv, av, this.entity, sqltypes).subscribe(
          res => {
            if ((typeof (res.code) === 'undefined') ||
              ((typeof (res.code) !== 'undefined') && (res.code === 0))) {
              // set table data
              cell.data(value);
              if (typeof (cellElement.attr('o-timestamp-value')) !== 'undefined') {
                cellElement.attr('o-timestamp-value', value);
              }
              if (typeof (cellElement.attr('o-number-value')) !== 'undefined') {
                cellElement.attr('o-number-value', value);
              }
              console.log('[ODataTable.updateCell]: after update', rowData);
            } else {
              console.log('[ODataTable.updateCell]: error', res.code);
              this.dialogService.alert('ERROR', 'MESSAGES.ERROR_UPDATE');
              cell.data(oldValue);
            }
            this.loaderSuscription.unsubscribe();
          },
          err => {
            console.log('[ODataTable.updateCell]: error', err);
            this.postIncorrectUpdate(err);
            cell.data(oldValue);
            this.loaderSuscription.unsubscribe();
          }
        );
      }
    } else {
      // removing input element
      cell.data(value);
    }
  }

  public updateRow(cellElement: any, av: any) {
    if (typeof (av) !== 'undefined') {
      let rowCurrentData = this.table.row(cellElement).data();
      console.log('[ODataTable.updateRow]: before update', rowCurrentData);
      let kv = {};
      for (let k = 0; k < this.keysArray.length; ++k) {
        let key = this.keysArray[k];
        kv[key] = rowCurrentData[key];
      }
      this.loaderSuscription = this.load();
      this.dataService[this.updateMethod](kv, av, this.entity)
        .subscribe(
        res => {
          if ((typeof (res.code) === 'undefined') ||
            ((typeof (res.code) !== 'undefined') && (res.code === 0))) {
            console.log('[ODataTable.updateRow]: after update', this.table.row(cellElement).data());
          } else {
            console.log('[ODataTable.updateRow]: error', res.code);
            this.dialogService.alert('ERROR', 'MESSAGES.ERROR_UPDATE');
          }
          this.loaderSuscription.unsubscribe();
        },
        err => {
          console.log('[ODataTable.updateRow]: error', err);
          this.postIncorrectUpdate(err);
          this.loaderSuscription.unsubscribe();
        }
        );
    }
  }

  protected handleColumnWidth(settings) {
    var self = this;
    var tableEl = ($('#' + this.oattr) as any);
    if (!tableEl.is(':visible')) {
      if (typeof this.columnWidthHandlerInterval === 'undefined') {
        this.columnWidthHandlerInterval = setInterval(function () {
          if (tableEl.is(':visible')) {
            clearInterval(self.columnWidthHandlerInterval);
            self.columnWidthHandlerInterval = undefined;
            self.handleColumnWidth(settings);
            console.log('columnWidthHandlerInterval');
          }
        }, 250);
      }
      return;
    }
    let api = ($ as any).fn.dataTable.Api(settings);
    let tableColumns = api.columns();
    let columnsNumber = tableColumns[0].length;

    var fixedWidthColumns = 0;
    fixedWidthColumns += (this.selectAllCheckbox ? 1 : 0);
    var actionColumns = 0;
    actionColumns += (this.editColumnIndex !== -1 ? 1 : 0);
    actionColumns += (this.detailColumnIndex !== -1 ? 1 : 0);
    fixedWidthColumns += actionColumns;

    let tableWidth = tableEl.outerWidth(true);
    let actionsWidth = ((fixedWidthColumns * 50) / tableWidth) * 100;

    var avoidIndex = [];
    let fixedWidths = 0;
    for (var i = 0; i < this.initialColumnsWidths.length; i++) {
      let colObj: any = this.initialColumnsWidths[i];
      let tableCol = api.column(colObj.name + ':name');
      if (tableCol) {
        avoidIndex.push(tableCol.index());
        let header = ($(tableCol.header()) as any);
        header.width(colObj.width);
        fixedWidths += parseInt(colObj.width);
      }
    }

    let remainingColumns = columnsNumber - this.initialColumnsWidths.length - fixedWidthColumns;
    let calcWidth = String((100 - actionsWidth - fixedWidths) / (remainingColumns || 1)) + '%';

    tableColumns.every(function (i) {
      if (avoidIndex.indexOf(i) === -1) {
        let columnWidth = '0px';
        let isActionColumn = (i >= (columnsNumber - actionColumns));
        if (self.selectAllCheckbox && i === 0) {
          columnWidth = '26px';
        } else if (!isActionColumn) {
          columnWidth = calcWidth;
        } else {
          // using width = 2 because padding-left and right is 24 (total width = 50)
          columnWidth = '2px';
        }
        ($(api.columns(i).header()) as any).width(columnWidth);
      }
    });
  }

  protected handleOrderIndex() {
    let header = $('#' + this.oattr + '_wrapper table thead') as any;
    header.find('.sorting-index').remove();
    let order = this.table.order();
    for (let i = 0; i < order.length; ++i) {
      let orderItem = order[i];
      header.find('th[data-column-index="' + orderItem[0] + '"]').append('<div class="sorting-index">' + (i + 1) + '</div>');
    }
  }

  public select(item: any) {
    this.table.rows().deselect();
    this.selectedItems = [item];
  }

  protected handleSelection(event: any, dt: Array<any>, type: string, indexes: Array<any>) {
    let localStorageState = localStorage.getItem('DataTables' + '_' + this.oattr + '_' + this.router.url);
    if (localStorageState) {
      let state = JSON.parse(localStorageState);
      state.selectedIndex = indexes[0];
      localStorage.setItem('DataTables' + '_' + this.oattr + '_' + this.router.url, JSON.stringify(state));

      let selection = this.table.rows(indexes).data().toArray();
      for (let i = 0; i < selection.length; ++i) {
        let selected = false;
        for (let j = this.selectedItems.length; j >= 0; --j) {
          if (selection[i] === this.selectedItems[j]) {
            selected = true;
            break;
          }
        }
        if (!selected) {
          this.selectedItems.push(selection[i]);
        }
      }
      this.updateDeleteButtonState();
      if (!this.isProgrammaticSelection) {
        ObservableWrapper.callEmit(this.onRowSelected, selection);
      }
    }
  }

  protected updateDeleteButtonState() {
    let deleteButton = $('#' + this.oattr + '_wrapper .generic-action-delete') as any;
    if (this.selectedItems.length > 0) {
      deleteButton.removeClass('disabled');
    } else {
      deleteButton.addClass('disabled');
    }
  }

  protected handleDeselection(event: any, dt: Array<any>, type: string, indexes: Array<any>) {
    this.lastDeselection = {
      event: event,
      dt: dt,
      type: type,
      indexes: indexes
    };

    let localStorageState = localStorage.getItem('DataTables' + '_' + this.oattr + '_' + this.router.url);
    if (localStorageState) {
      let state = JSON.parse(localStorageState);
      delete state.selectedIndex;
      localStorage.setItem('DataTables' + '_' + this.oattr + '_' + this.router.url, JSON.stringify(state));
    }

    let selection = this.table.rows(indexes).data().toArray();
    for (let i = 0; i < selection.length; ++i) {
      for (let j = this.selectedItems.length; j >= 0; --j) {
        if (selection[i] === this.selectedItems[j]) {
          this.selectedItems.splice(j, 1);
          break;
        }
      }
    }
    this.updateDeleteButtonState();
    if (!this.isProgrammaticSelection) {
      ObservableWrapper.callEmit(this.onRowDeselected, selection);
    }
  }

  protected handleSelectAllClick(event: any) {
    this.setSelectAllCheckboxValue(event.target.checked);
  }

  public setSelectAllCheckboxValue(val: boolean) {
    if (this.selectAllCheckbox) {
      let headerCheckboxCol = this.tableHtmlEl.find('th.o-table-column-select-checkbox') as any;
      let wasIndeterminate = headerCheckboxCol.hasClass('mat-checkbox-indeterminate');

      headerCheckboxCol.attr('class', 'o-table-column-select-checkbox');
      if (val) {
        headerCheckboxCol.addClass('mat-checkbox-checked mat-checkbox-anim-unchecked-checked');
      } else if (wasIndeterminate) {
        headerCheckboxCol.addClass('mat-checkbox-anim-indeterminate-unchecked');
      } else {
        headerCheckboxCol.addClass('mat-checkbox-anim-checked-unchecked');
      }
      var self = this;
      this.table.rows({ filter: 'applied' }).every(function (el) {
        let checkboxEl = self.table.row(el).node().querySelector('input[type="checkbox"].select-row');
        if (checkboxEl) {
          checkboxEl.checked = val;
          ($(checkboxEl) as any).change();
        }
      });
    }
  }

  public selectRowsByData(data: Array<any>, value: boolean = true) {
    this.isProgrammaticSelection = true;
    let rowsSelectors = [];
    for (var i = 0; i < data.length; i++) {
      let current = data[i];
      let currentSelector = {};
      this.keysArray.forEach(key => currentSelector[key] = current[key]);
      rowsSelectors.push(currentSelector);
    }
    if (this.table && rowsSelectors.length) {
      var self = this;
      let alterRowIndexes = [];
      this.table.rows({ filter: 'applied' }).eq(0).each(function (index) {
        var row = self.table.row(index);
        var rowData = row.data();
        rowsSelectors.forEach(selectorObj => {
          let props = Object.keys(selectorObj);
          let alterRow = true;
          for (var i = 0; i < props.length; i++) {
            alterRow = alterRow && (selectorObj[props[i]] === rowData[props[i]]);
          }
          if (alterRow && self.selectAllCheckbox) {
            let checkboxEl = row.node().querySelector('input[type="checkbox"].select-row');
            if (checkboxEl) {
              checkboxEl.checked = value;
              ($(checkboxEl) as any).change();
            }
          } else if (alterRow) {
            alterRowIndexes.push(index);
          }
        });
      });
      if (!this.selectAllCheckbox && alterRowIndexes.length) {
        if (value) {
          this.table.rows(alterRowIndexes).select();
        } else {
          this.table.rows(alterRowIndexes).deselect();
        }
      }
    }
    this.isProgrammaticSelection = false;
  }

  protected handleRowCheckboxChange(event: any) {
    let rowEL = ($(event.target) as any).parents('tr:first');
    let checkBoxColumn = rowEL.find('.o-table-column-select-checkbox:first');
    checkBoxColumn.attr('class', 'o-table-column-select-checkbox');

    let tableRow = this.table.rows(rowEL);
    let rowData = tableRow.data().toArray()[0];
    if (event.target.checked) {
      checkBoxColumn.addClass('mat-checkbox-checked mat-checkbox-anim-unchecked-checked');
      tableRow.select();
      this.selectedItems.push(rowData);
    } else {
      checkBoxColumn.addClass('mat-checkbox-anim-checked-unchecked');
      tableRow.deselect();
      this.selectedItems.splice(this.selectedItems.indexOf(rowData), 1);
      var selectAllEL = this.tableHtmlEl.find('th #select_all')[0];
      // If "Select all" control is checked and has 'indeterminate' property
      if (selectAllEL && selectAllEL.checked && ('indeterminate' in selectAllEL)) {
        // Set visual state of "Select all" control as 'indeterminate'
        selectAllEL.indeterminate = true;
        let headerCheckboxCol = this.tableHtmlEl.find('th.o-table-column-select-checkbox');
        headerCheckboxCol.attr('class', 'o-table-column-select-checkbox');
        headerCheckboxCol.addClass('mat-checkbox-indeterminate mat-checkbox-anim-checked-indeterminate');
      }
    }
    this.updateDeleteButtonState();
    if (!this.isProgrammaticSelection && event.target.checked) {
      ObservableWrapper.callEmit(this.onRowSelected, rowData);
    } else if (!this.isProgrammaticSelection) {
      ObservableWrapper.callEmit(this.onRowDeselected, rowData);
    }
  }

  protected handleClick(event: any) {
    let item = this.table.row(event.target).data();
    ObservableWrapper.callEmit(this.onClick, item);
    let cellEl = $(this.table.cell(event.target).nodes()) as any;
    if (this.oenabled && (this.detailMode === 'click') && !cellEl.hasClass('editable')) {
      this.viewDetail(item);
    }
  }

  protected handleDoubleClick(event: any) {
    let item = this.table.row(event.target).data();
    ObservableWrapper.callEmit(this.onDoubleClick, item);
    let cellEl = $(this.table.cell(event.target).nodes()) as any;
    cellEl.addClass('noselect');
    if (this.oenabled && (this.detailMode === 'doubleclick') && !cellEl.hasClass('editable')) {
      this.viewDetail(item);
    }
    cellEl.removeClass('noselect');
  }

  protected initColumnResize() {

    if (typeof (this.tableHtmlEl) !== 'undefined') {
      let self = this;
      let disabledResizeColumns = [];

      if (this.selectAllCheckbox) {
        disabledResizeColumns.push(0);
      }
      if (this.editButtonInRow) {
        disabledResizeColumns.push(this.editColumnIndex);
        if (disabledResizeColumns.indexOf(this.editColumnIndex - 1) === -1) {
          disabledResizeColumns.push(this.editColumnIndex - 1);
        }
      }
      if (this.detailButtonInRow) {
        disabledResizeColumns.push(this.detailColumnIndex);
        if (disabledResizeColumns.indexOf(this.detailColumnIndex - 1) === -1) {
          disabledResizeColumns.push(this.detailColumnIndex - 1);
        }
      }

      ($('#' + this.oattr + '_wrapper .JCLRgrips') as any).remove();

      if (!this.tableHtmlEl.colResizable) {
        console.error('colResizable not defined');
        return;
      }

      this.tableHtmlEl.colResizable({
        liveDrag: false,
        postbackSafe: false,
        partialRefresh: true,
        minWidth: 50,
        disabledColumns: disabledResizeColumns,
        onResize: (e) => {
          self.tableHtmlEl.siblings('.JCLRgrips').find('> .JCLRgrip').height(self.tableHtmlEl.outerHeight(true));
        }
      });
      this.tableHtmlEl.siblings('.JCLRgrips').find('> .JCLRgrip').height(this.tableHtmlEl.outerHeight(true));
    }
  }

  protected initColumnGroup() {
    let header = this.tableHtmlEl.find('th');
    header.on('click', (event: any) => {
      // TODO: only .off this event handler, instead of stopping propagation
      if (event.isPropagationStopped()) {
        return;
      }
      event.stopPropagation();
      let groupButton = $('#' + this.oattr + '_wrapper .generic-action-group') as any;
      if (groupButton.hasClass('active')) {
        header.removeClass('group');
        let th = $(event.target) as any;
        let order = this.table.order();
        let columnIndex = parseInt(th.attr('data-column-index'));
        if (this.groupColumnIndex === columnIndex) {
          if ((order[0][0] === this.groupColumnIndex) && (order[0][1] === ODataTableComponent.TYPE_ASC_NAME)) {
            this.groupColumnOrder = ODataTableComponent.TYPE_DESC_NAME;
            order[0][1] = this.groupColumnOrder;
            th.addClass('group');
          } else {
            order = order.slice(1);
            this.groupColumnIndex = -1;
          }
        } else {
          if (this.groupColumnIndex !== -1) {
            order = order.slice(1);
          }
          this.groupColumnIndex = columnIndex;
          this.groupColumnOrder = ODataTableComponent.TYPE_ASC_NAME;
          let orderByGroupColumn = true;
          for (let i = 0; i < order.length; ++i) {
            if (order[i][0] === this.groupColumnIndex) {
              orderByGroupColumn = false;
              break;
            }
          }
          if (orderByGroupColumn) {
            order.unshift([this.groupColumnIndex, this.groupColumnOrder]);
          }
          th.addClass('group');
        }
        this.table.order(order);
        this.dataTable.fnDraw();
        let emptyRow = $('.dataTables_empty') as any;
        if (emptyRow.length > 0) {
          emptyRow.parent().addClass('empty');
        }
      }
    });
  }

  /**
    * @deprecated
  */
  update(parentItem: any = undefined, ovrrArgs?: any) {
    this.queryData(parentItem, ovrrArgs);
  }

  queryData(parentItem: any = undefined, ovrrArgs?: any) {
    if (!this.initialized) {
      this.pendingQuery = true;
      this.pendingQueryFilter = parentItem;
      return;
    }
    let queryMethodName = this.pageable ? this.paginatedQueryMethod : this.queryMethod;
    if (this.dataService && (queryMethodName in this.dataService) && this.entity) {
      this.pendingQuery = false;
      this.pendingQueryFilter = undefined;

      if (typeof (this.dataTable) !== 'undefined' && !this.pageable) {
        this.dataTable.fnClearTable(false);
      }

      if (this.filterForm && (typeof (parentItem) === 'undefined')) {
        parentItem = {};
        let formComponents = this.form.getComponents();
        if ((this.dataParentKeys.length > 0) && (Object.keys(formComponents).length > 0)) {
          for (let k = 0; k < this.dataParentKeys.length; ++k) {
            let parentKey = this.dataParentKeys[k];
            if (formComponents.hasOwnProperty(parentKey['alias'])) {
              let currentData = formComponents[parentKey['alias']].getValue();
              switch (typeof (currentData)) {
                case 'string':
                  if (currentData.trim().length > 0) {
                    parentItem[parentKey['alias']] = currentData.trim();
                  }
                  break;
                case 'number':
                  if (!isNaN(currentData)) {
                    parentItem[parentKey['alias']] = currentData;
                  }
                  break;
              }
            }
          }
        }
      }

      if ((this.dataParentKeys.length > 0) && (typeof (parentItem) === 'undefined')) {
        this.dataArray = [];
        this.dataTable.fnClearTable(false);
        this.dataTable.fnDraw();
        let emptyRow = $('.dataTables_empty') as any;
        if (emptyRow.length > 0) {
          emptyRow.parent().addClass('empty');
        }
      } else {

        let filter = {};
        if ((this.dataParentKeys.length > 0) && (typeof (parentItem) !== 'undefined')) {
          for (let k = 0; k < this.dataParentKeys.length; ++k) {
            let parentKey = this.dataParentKeys[k];
            if (parentItem.hasOwnProperty(parentKey['alias'])) {
              let currentData = parentItem[parentKey['alias']];
              if (currentData instanceof OFormValue) {
                currentData = currentData.value;
              }
              filter[parentKey['name']] = currentData;
            }
          }
        }
        if (this.querySuscription) {
          this.querySuscription.unsubscribe();
          this.loaderSuscription.unsubscribe();
        }
        this.loaderSuscription = this.load();
        let queryArgs = this.getQueryArguments(filter, ovrrArgs);
        var self = this;
        this.querySuscription = this.dataService[queryMethodName].apply(this.dataService, queryArgs).subscribe(res => {
          let data = undefined;
          if (Util.isArray(res)) {
            data = res;
          } else if ((res.code === 0) && Util.isArray(res.data)) {
            data = (res.data !== undefined) ? res.data : [];
            if (self.pageable) {
              self.updatePaginationInfo(res);
            }
          }
          // set table data
          if (Util.isArray(data)) {
            self.dataTable.fnClearTable(false);
            if (self.pageable) {
              self.setPaginatedTableData(data, ovrrArgs);
            } else {
              self.dataArray = data;
            }

            if (self.dataArray.length > 0) {
              self.dataTable.fnAddData(self.dataArray);
            }

            if (self.table && self.pageable) {
              let pagesInfo = self.table.page.info();
              let activePage = pagesInfo.pages > 0 ? (pagesInfo.pages - 1) : 0;
              if (!self.singlePageMode && ovrrArgs && ovrrArgs.hasOwnProperty('resultRecordsIndex')) {
                activePage = Math.floor((ovrrArgs['resultRecordsIndex'] / self.queryRows));
              }
              self.table.page(activePage).draw(false);
              self.updatePaginationFooterText(true);
            } else {
              self.dataTable.fnDraw();
            }

            let emptyRow = $('.dataTables_empty') as any;
            if (emptyRow.length > 0) {
              emptyRow.parent().addClass('empty');
            }
            // if (typeof (self.state.start) === 'number' && typeof (self.state.length) === 'number') {
            //   let newPage = Math.ceil(self.state.start / self.state.length);
            //   if (self.table && newPage !== self.table.page.info().page) {
            //     self.dataTable.fnPageChange(newPage);
            //   }
            // }
            self.selectedItems = [];

            if (typeof (self.state.selectedIndex) !== 'undefined') {
              let selectedRow = self.table.rows(self.state.selectedIndex);
              let selectedRowData = selectedRow.data().toArray()[0];
              if (self.selectedItems.indexOf(selectedRowData) === -1) {
                self.selectedItems.push(selectedRowData);
              }
            }
            self.updateDeleteButtonState();
          } else {
            console.log('[ODataTable.queryData]: error code ' + res.code + ' when querying data');
            self.setDataArray([]);
            self.dataTable.fnClearTable(true);
          }
          self.loaderSuscription.unsubscribe();
          if (self.pageable) {
            ObservableWrapper.callEmit(self.onPaginatedTableDataLoaded, data);
          }
          ObservableWrapper.callEmit(self.onTableDataLoaded, self.dataArray);
        },
          err => {
            console.log('[ODataTable.queryData]: error', err);
            self.setDataArray([]);
            self.dataTable.fnClearTable(true);
            self.loaderSuscription.unsubscribe();
            self.postIncorrectQuery(err);

          }
        );
      }
    }
  }

  protected postIncorrectQuery(result: any) {
    if (result) {
      this.dialogService.alert('ERROR', result);
    } else {
      this.dialogService.alert('ERROR', 'MESSAGES.ERROR_QUERY');
    }
  }

  protected postIncorrectDelete(result: any) {
    if (result && typeof result !== 'object') {
      this.dialogService.alert('ERROR', result);
    } else {
      this.dialogService.alert('ERROR', 'MESSAGES.ERROR_DELETE');
    }
  }
  protected postIncorrectUpdate(result: any) {
    if (result && typeof result !== 'object') {
      this.dialogService.alert('ERROR', result);
    } else {
      this.dialogService.alert('ERROR', 'MESSAGES.ERROR_UPDATE');
    }
  }

  protected postIncorrectInsert(result: any) {
    if (result && typeof result !== 'object') {
      this.dialogService.alert('ERROR', result);
    } else {
      this.dialogService.alert('ERROR', 'MESSAGES.ERROR_INSERT');
    }
  }

  getAttributesValuesToQuery(): Object {
    let columns = [];
    this.colArray.forEach(col => {
      if (this.asyncLoadColumns.indexOf(col) === -1) {
        columns.push(col);
      }
    });
    return columns;
  }

  getQueryArguments(filter: Object, ovrrArgs?: any): Array<any> {
    let queryArguments = super.getQueryArguments(filter, ovrrArgs);
    queryArguments[1] = this.getAttributesValuesToQuery();
    return queryArguments;
  }

  protected setPaginatedTableData(data: any, ovrrArgs: any) {
    let parsedDataArray = [];
    if (this.singlePageMode) {
      parsedDataArray = data;
    } else if (ovrrArgs && ovrrArgs.hasOwnProperty('resultRecordsIndex')) {
      let initIndex = ovrrArgs['resultRecordsIndex'];
      let endIndex = (ovrrArgs && ovrrArgs['replace']) ? ovrrArgs['resultRecordsIndex'] + data.length : ovrrArgs['resultRecordsIndex'];
      let removeRowsIdx = [];
      if (ovrrArgs && ovrrArgs['replace']) {
        for (let ri = initIndex; ri < endIndex; ri++) {
          removeRowsIdx.push(ri);
        }
      }
      if (removeRowsIdx.length) {
        this.dataTable.fnDeleteRow(removeRowsIdx, undefined, false);
      }
      parsedDataArray = this.dataArray.slice(0, initIndex).concat(data).concat(this.dataArray.slice(endIndex));
    } else {
      parsedDataArray = this.dataArray.concat(data);
    }
    this.dataArray = parsedDataArray;
  }

  updatePaginationInfo(queryRes: any) {
    super.updatePaginationInfo(queryRes);
    if (!this.singlePageMode) {
      this.storedRecordsIndexes.push({
        start: queryRes.startRecordIndex,
        end: queryRes.startRecordIndex + (queryRes.data ? queryRes.data.length : 0)
      });
    }
  }

  protected areRecordsLoaded(startIndex: Number, endIndex: Number): boolean {
    let result = false;
    for (var i = 0; i < this.storedRecordsIndexes.length; i++) {
      var storedStart = this.storedRecordsIndexes[i].start;
      var storedEnd = this.storedRecordsIndexes[i].end;

      if ((startIndex >= storedStart && startIndex <= storedEnd)
        && (endIndex >= storedStart && endIndex <= storedEnd)) {
        return true;
      }
    }
    return result;
  }

  protected updatePaginationFooterText(redraw: any) {
    let tableWrapperEl = this.tableHtmlEl.parents('.dataTables_wrapper:first');
    if (tableWrapperEl.length === 0 || !redraw) {
      return;
    }

    let footerTextEl = tableWrapperEl.find('.dataTables_pagination_wrapper .dataTables_info');
    if (footerTextEl && footerTextEl.length && this.state.queryTotalRecordNumber > 0) {
      let existingText = footerTextEl.text().trim();
      const tableSettings = this.table.settings();
      const isFiltering = ((tableSettings.search() || '').length > 0);
      let initIndex = (this.state.queryRecordOffset - this.queryRows) + 1;
      initIndex = initIndex <= 0 ? 1 : initIndex;
      let endIndex = (this.state.queryRecordOffset < this.state.queryTotalRecordNumber) ? (initIndex + this.queryRows - 1) : this.state.queryRecordOffset;
      if (isFiltering) {
        endIndex = this.table.rows({ filter: 'applied' })[0].length;
      }
      let newText = initIndex + ' - ' + endIndex + ' ';
      let match = existingText.match('[0-9]+ - [0-9]+');
      let initTrimIdx = existingText.search('\d');
      if (match && match.length === 1) {
        initTrimIdx = match[0].length + 1;
      }
      if (isFiltering) {
        newText += ' ' + existingText.substring(initTrimIdx);
      } else {
        newText += existingText.substring(initTrimIdx, existingText.lastIndexOf(' '));
        newText += ' ' + this.state.queryTotalRecordNumber;
      }
      footerTextEl.text(newText);
    }
  }

  protected updatePageableTable(redraw: any) {
    if (!this.table || !this.pageable) {
      return;
    }
    let tableWrapperEl = this.tableHtmlEl.parents('.dataTables_wrapper:first');
    let existingRows = this.dataArray.length;
    if (tableWrapperEl.length === 0 || existingRows === 0) {
      return;
    }
    this.updatePaginationFooterText(redraw);

    var currentPageInfo = this.table.page.info();

    var self = this;
    var tableState = this.state;

    let activateNextBtns = (tableState.queryRecordOffset < tableState.queryTotalRecordNumber);
    if (activateNextBtns) {
      let nextBtn = tableWrapperEl.find('.dataTables_pagination_wrapper .next');
      if (nextBtn) {
        nextBtn.removeClass('disabled').off('click').one('click', function () {
          let pagesInfo = self.table.page.info();

          let newStartRecord = Math.max(tableState.queryRecordOffset, pagesInfo.end);
          let newEndRecord = Math.min(newStartRecord + self.queryRows, tableState.queryTotalRecordNumber);
          let queryLength = Math.min(self.queryRows, newEndRecord - newStartRecord);

          let areRecordsLoaded = self.areRecordsLoaded(newStartRecord, newEndRecord);
          if (!areRecordsLoaded) {
            let queryArgs = {
              offset: newStartRecord,
              length: queryLength,
              resultRecordsIndex: Math.min(newStartRecord, self.dataArray.length)
            };
            self.queryData(self.parentItem, queryArgs);
          } else {
            tableState.queryRecordOffset = newEndRecord;
            self.table.page('next').draw(false);
            self.updatePaginationFooterText(true);
          }
        });
      }

      let lastBtn = tableWrapperEl.find('.dataTables_pagination_wrapper .last');
      if (lastBtn) {
        lastBtn.removeClass('disabled').off('click').one('click', function () {
          let lastPageRows = (tableState.queryTotalRecordNumber % self.queryRows) || self.queryRows;
          let newStartRecord = tableState.queryTotalRecordNumber - lastPageRows;
          let newEndRecord = newStartRecord + lastPageRows;
          let areRecordsLoaded = self.areRecordsLoaded(newStartRecord, newEndRecord);
          if (!areRecordsLoaded) {
            let queryArgs = {
              offset: newStartRecord,
              length: lastPageRows
            };
            self.queryData(self.parentItem, queryArgs);
          } else {
            tableState.queryRecordOffset = newEndRecord;
            self.table.page('last').draw(false);
            self.updatePaginationFooterText(true);
          }
        });
      }
    }

    let activatePrevBtns = self.singlePageMode ? tableState.queryRecordOffset > self.queryRows : (currentPageInfo.page > 0 || !self.areRecordsLoaded(0, 0));
    if (activatePrevBtns) {
      let prevBtn = tableWrapperEl.find('.dataTables_pagination_wrapper .previous');
      if (prevBtn) {
        prevBtn.removeClass('disabled').off('click').one('click', function () {
          let pagesInfo = self.table.page.info();

          let newStartRecord = (Math.max(tableState.queryRecordOffset - (pagesInfo.end - pagesInfo.start), pagesInfo.start) - self.queryRows);
          let newEndRecord = newStartRecord + self.queryRows;

          let areRecordsLoaded = self.areRecordsLoaded(newStartRecord, newEndRecord);
          if (!areRecordsLoaded) {
            let queryArgs = {
              offset: newStartRecord,
              length: self.queryRows,
              resultRecordsIndex: Math.min(newStartRecord, self.dataArray.length - (tableState.queryTotalRecordNumber - newEndRecord))
            };
            self.queryData(self.parentItem, queryArgs);
          } else {
            tableState.queryRecordOffset = newEndRecord;
            self.table.page('previous').draw(false);
            self.updatePaginationFooterText(true);
          }
        });
      }

      let firstBtn = tableWrapperEl.find('.dataTables_pagination_wrapper .first');
      if (firstBtn) {
        firstBtn.removeClass('disabled').off('click').one('click', function () {
          let areRecordsLoaded = self.areRecordsLoaded(0, self.queryRows);
          if (!areRecordsLoaded) {
            let queryArgs = {
              offset: 0,
              length: self.queryRows,
              resultRecordsIndex: 0
            };
            self.queryData(self.parentItem, queryArgs);
          } else {
            tableState.queryRecordOffset = self.queryRows;
            self.table.page('first').draw(false);
            self.updatePaginationFooterText(true);
          }
        });
      }
    }
  }

  public remove(clearSelectedItems: boolean = false) {
    if ((this.keysArray.length > 0) && (this.selectedItems.length > 0)) {
      this.dialogService.confirm('CONFIRM', 'MESSAGES.CONFIRM_DELETE')
        .then(
        res => {
          if (res === true) {

            if (this.dataService && (this.deleteMethod in this.dataService) && this.entity && (this.keysArray.length > 0)) {

              let filters = [];
              this.selectedItems.map(item => {
                let kv = {};
                for (let k = 0; k < this.keysArray.length; ++k) {
                  let key = this.keysArray[k];
                  kv[key] = item[key];
                }
                filters.push(kv);
              });

              let observable = (Observable as any).from(filters)
                .map(kv => this.dataService[this.deleteMethod](kv, this.entity)).mergeAll();
              observable.subscribe(
                res => {
                  console.log('[ODataTable.remove]: response', res);
                  ObservableWrapper.callEmit(this.onRowDeleted, this.selectedItems);
                },
                error => {
                  console.log('[ODataTable.remove]: error', error);
                  this.dialogService.alert('ERROR', 'MESSAGES.ERROR_DELETE');
                },
                () => {
                  console.log('[ODataTable.remove]: success');
                  this.setTableInitialState();
                  let queryArgs = {
                    offset: 0,
                    length: this.queryRows
                  };
                  this.queryData(this.parentItem, queryArgs);
                }
              );

            } else {
              // remove local
              this.deleteLocalItems();
              this.updateDeleteButtonState();
              this.dataTable.fnClearTable(false);
              if (this.dataArray.length > 0) {
                this.dataTable.fnAddData(this.dataArray);
              }
              this.dataTable.fnDraw();
              let emptyRow = $('.dataTables_empty') as any;
              if (emptyRow.length > 0) {
                emptyRow.parent().addClass('empty');
              }
              ObservableWrapper.callEmit(this.onRowDeleted, this.selectedItems);
            }
          } else if (clearSelectedItems) {
            this.selectedItems = [];
          }
        }
        );
    }
  }

  protected add() {
    let route = [];
    if (this.detailFormRoute) {
      route.push(this.detailFormRoute);
    }
    route.push('new');
    // adding parent-keys info...
    if ((this.dataParentKeys.length > 0) && (typeof (this.parentItem) !== 'undefined')) {
      let pKeys = {};
      for (let k = 0; k < this.dataParentKeys.length; ++k) {
        let parentKey = this.dataParentKeys[k];
        if (this.parentItem.hasOwnProperty(parentKey['alias'])) {
          let currentData = this.parentItem[parentKey['alias']];
          if (currentData instanceof OFormValue) {
            currentData = currentData.value;
          }
          pKeys[parentKey['name']] = currentData;
        }
      }
      if (Object.keys(pKeys).length > 0) {
        let encoded = Util.encodeParentKeys(pKeys);
        route.push({ 'pk': encoded });
      }
    }
    let extras = { relativeTo: this.actRoute };
    this.router.navigate(
      route,
      extras
    ).catch(err => {
      console.error(err.message);
    });
  }

  protected getTableOptions() {
    let options = [];
    var self = this;
    var columnsSelector = ':visible:not(.o-table-select-checkbox):not(.o-table-column-action)';
    // export actions
    if (this.exportButton) {
      options.push({
        extend: 'copyHtml5',
        name: 'copyHtml5',
        text: this.translateService.get('TABLE.BUTTONS.COPY_TO_CLIPBOARD'),
        className: 'export-action',
        exportOptions: {
          columns: columnsSelector
        }
      });
      options.push({
        extend: 'print',
        name: 'print',
        text: this.translateService.get('TABLE.BUTTONS.PRINT'),
        className: 'export-action',
        exportOptions: {
          columns: columnsSelector
        }
      });
      options.push({
        extend: 'excelHtml5',
        text: 'Excel',
        name: 'excel',
        className: 'export-action',
        filename: this.title ? this.title : '*',
        exportOptions: {
          columns: columnsSelector
        }
      });
      options.push({
        extend: 'csvHtml5',
        text: 'CSV',
        name: 'csv',
        className: 'export-action',
        filename: this.title ? this.title : '*',
        fieldSeparator: ',',
        extension: '.csv',
        exportOptions: {
          columns: columnsSelector
        }
      });
      options.push({
        extend: 'pdfHtml5',
        text: 'PDF',
        name: 'pdf',
        className: 'export-action',
        filename: this.title ? this.title : '*',
        title: this.title ? this.title : '*',
        orientation: 'portrait',
        pageSize: 'A4',
        exportOptions: {
          columns: columnsSelector,
          orthogonal: 'export'
        }
      });
      options.push({
        text: this.translateService.get('TABLE.BUTTONS.EXPORT'),
        className: 'generic-action generic-action-export',
        action: () => {
          self.exportButtonAction();
        }
      });
    }

    // group rows
    if (this.columnsGroupButton) {
      options.push({
        text: this.translateService.get('TABLE.BUTTONS.GROUP_ROWS'),
        className: 'generic-action generic-action-group',
        action: () => {
          self.columnsGroupButtonAction();
        }
      });
    }

    // resize columns
    if (this.columnsResizeButton) {
      options.push({
        text: this.translateService.get('TABLE.BUTTONS.RESIZE_COLUMNS'),
        className: 'generic-action generic-action-resize',
        action: () => {
          self.columnsResizeButtonAction();
        }
      });
    }

    // columns visibility option
    if (this.columnsVisibilityButton) {
      let colVisOptions = {
        extend: 'colvis',
        text: this.translateService.get('TABLE.BUTTONS.COLVIS'),
        className: 'generic-action generic-action-view-column',
        collectionLayout: 'fixed',
        columns: [],
        columnText: function (dt, idx, title) {
          if (!title || title.length === 0) {
            title = self.translateService.get(self.visibleColumnsArray[idx]);
          }
          return title;
        }
      };
      for (var i = 0; i < this.visibleColumnsArray.length; i++) {
        colVisOptions.columns.push(this.visibleColumnsArray[i] + ':name');
      }
      options.push(colVisOptions);
    }
    return options;
  }

  protected exportButtonAction() {
    this.showExportOptions = !this.showExportOptions;
  }

  protected columnsGroupButtonAction(event?) {
    if (event) {
      this.toggleButtonActiveClass(event);
    }
    let header = this.tableHtmlEl.find('th');
    let groupButton = $('#' + this.oattr + '_wrapper .generic-action-group') as any;
    if (groupButton.hasClass('active')) {
      groupButton.removeClass('active');
      header.removeClass('grouping');
      this.dataTable.fnSortOnOff('_all', true);
    } else {
      groupButton.addClass('active');
      header.addClass('grouping');
      this.dataTable.fnSortOnOff('_all', false);
    }
  }

  protected columnsResizeButtonAction(event?) {
    if (event) {
      this.toggleButtonActiveClass(event);
    }
    let resizeButton = $('#' + this.oattr + '_wrapper .generic-action-resize') as any;
    if (resizeButton.hasClass('active')) {
      resizeButton.removeClass('active');
      ($('#' + this.oattr + '_wrapper .JCLRgrips') as any).remove();
    } else {
      resizeButton.addClass('active');
      this.initColumnResize();
    }
  }

  protected columnsVisibilityButtonAction() {
    this.table.buttons('.generic-action-view-column').trigger();
  }

  protected exportAction(buttonName: string) {
    this.table.buttons(buttonName + ':name').trigger();
  }

  protected getTableButtons() {
    let buttons = [];
    let buttonTextClass = this.showTableButtonsText ? '' : ' hidden-action-text';
    // add
    if (this.insertButton) {
      buttons.push({
        text: this.translateService.get('TABLE.BUTTONS.ADD'),
        className: 'generic-action generic-action-add' + buttonTextClass,
        action: () => {
          this.add();
        }
      });
    }
    // delete
    if (this.deleteButton) {
      buttons.push({
        text: this.translateService.get('TABLE.BUTTONS.DELETE'),
        className: 'generic-action generic-action-delete disabled' + buttonTextClass,
        action: () => {
          this.remove();
        }
      });
    }
    // refresh
    if (this.refreshButton) {
      buttons.push({
        text: this.translateService.get('TABLE.BUTTONS.REFRESH'),
        className: 'generic-action generic-action-refresh' + buttonTextClass,
        action: () => {
          this.reloadData();
        }
      });
    }
    for (var i = 0; i < this.headerButtons.length; i++) {
      var headerBtn = this.headerButtons[i];
      buttons.push({
        text: this.translateService.get(headerBtn.getLabel()),
        className: 'custom-generic-action icon-' + headerBtn.getIcon() + buttonTextClass,
        action: () => {
          headerBtn.innerOnClick();
        }

      });
    }
    return buttons;
  }

  protected getLanguageLabels() {
    let labels = {
      'emptyTable': this.translateService.get('TABLE.EMPTY'),
      'info': this.translateService.get('TABLE.INFO'),
      'infoEmpty': this.translateService.get('TABLE.INFO_EMPTY'),
      'infoFiltered': this.translateService.get('TABLE.INFO_FILTERED'),
      'infoPostFix': this.translateService.get('TABLE.INFO_POST_FIX'),
      'lengthMenu': this.translateService.get('TABLE.LENGTH_MENU'),
      'loadingRecords': this.translateService.get('TABLE.LOADING_RECORDS'),
      'processing': this.translateService.get('TABLE.PROCESSING'),
      'search': this.translateService.get('TABLE.SEARCH'),
      'zeroRecords': this.translateService.get('TABLE.ZERO_RECORDS'),
      'paginate': {
        'first': this.translateService.get('TABLE.PAGINATE.FIRST'),
        'last': this.translateService.get('TABLE.PAGINATE.LAST'),
        'next': this.translateService.get('TABLE.PAGINATE.NEXT'),
        'previous': this.translateService.get('TABLE.PAGINATE.PREVIOUS')
      },
      'aria': {
        'sortAscending': this.translateService.get('TABLE.ARIA.SORT_ASCENDING'),
        'sortDescending': this.translateService.get('TABLE.ARIA.SORT_DESCENDING')
      },
      'buttons': {
        'colvis': this.translateService.get('TABLE.BUTTONS.COLVIS'),
        'copyTitle': this.translateService.get('TABLE.BUTTONS.COPY_TITLE'),
        'copySuccess': {
          '_': this.translateService.get('TABLE.BUTTONS.COPY_SUCCESS._'),
          '1': this.translateService.get('TABLE.BUTTONS.COPY_SUCCESS.1')
        }
      },
      'select': {
        'rows': {
          '_': this.translateService.get('TABLE.SELECT.ROWS._'),
          '0': this.translateService.get('TABLE.SELECT.ROWS.0'),
          '1': this.translateService.get('TABLE.SELECT.ROWS.1')
        }
      }
    };
    return labels;
  }

  public isColumnEditable(column: string) {
    return (this.editableColumnsArray.indexOf(column) !== -1);
  }

  public renderRowRenderers(cellElement: any, rowData: any) {
    let currentCols = this.table.settings()[0].aoColumns;
    let rowEl = $(this.table.row(cellElement).nodes()) as any;
    rowEl.removeClass('editRow');
    let rowCellsEl = rowEl.find('td');
    for (let i = 0; i < rowCellsEl.length; ++i) {
      let cellEl = $(rowCellsEl[i]) as any;
      let colIndex = this.table.column(rowCellsEl[i]).index();
      if (colIndex < currentCols.length) {
        let colDef = currentCols[colIndex];
        if (colDef.editable) {
          if (this.editOnFocus) {
            cellEl.addClass('editable');
          }
          let data = rowData[colDef.name];
          this.table.cell(rowCellsEl[i]).data(data);
        }
      }
    }
  }

  public renderRowEditors(cellElement: any) {
    let currentCols = this.table.settings()[0].aoColumns;
    let rowEl = $(this.table.row(cellElement).nodes()) as any;
    rowEl.addClass('editRow');
    let rowCellsEl = rowEl.find('td');
    for (let i = 0; i < rowCellsEl.length; ++i) {
      let cellEl = $(rowCellsEl[i]) as any;
      cellEl.removeClass('editable focus');
      let cellData = this.table.cell(rowCellsEl[i]).data();
      let colIndex = this.table.column(rowCellsEl[i]).index();
      if (colIndex < currentCols.length) {
        let colDef = currentCols[colIndex];
        if (colDef.editable && (typeof (colDef.component) !== 'undefined') &&
          (typeof (colDef.component.editor) !== 'undefined')) {
          colDef.component.editor.createEditorForInsertTable(cellEl, cellData);
        } else {
          //cellEl.html('');
          //cellEl.off();
        }
      } else {
        //cellEl.html('');
        //cellEl.off();
      }
    }
  }

  public getRowEditorsAttrValues(cellElement: any) {
    let rowData = undefined;
    let currentCols = this.table.settings()[0].aoColumns;
    let rowEl = $(this.table.row(cellElement).nodes()) as any;
    let rowCellsEl = rowEl.find('td');
    for (let i = 0; i < rowCellsEl.length; ++i) {
      // let cellEl = $(rowCellsEl[i]) as any;
      let colIndex = this.table.column(rowCellsEl[i]).index();
      if (colIndex < currentCols.length) {
        let colDef = currentCols[colIndex];
        if (colDef.editable && (typeof (colDef.component) !== 'undefined') &&
          (typeof (colDef.component.editor) !== 'undefined')) {
          let cellData = this.table.cell(rowCellsEl[i]).data();
          let newData = colDef.component.editor.getInsertTableValue();
          if (cellData !== newData) {
            if (typeof (rowData) === 'undefined') {
              rowData = {};
            }
            rowData[colDef.name] = newData;
          }
        }
      }
    }
    return rowData;
  }

  public registerHeaderButton(button: ODataTableButtonComponent) {
    this.headerButtons.push(button);
    if (this.dataTableOptions) {
      this.dataTableOptions.buttons.push({
        text: this.translateService.get(button.getLabel()),
        className: 'custom-generic-action icon-' + button.getIcon() + (this.showTableButtonsText ? '' : ' hidden-action-text'),
        action: function () {
          button.innerOnClick();
        }
      });
    }
  }

  public registerHeaderOption(option: ODataTableOptionComponent) {
    this.headerOptions.push(option);
  }

  public getRowDataFromColumn(tableColumn: ODataTableColumnComponent) {
    if (tableColumn && tableColumn.cellElement) {
      return this.table.row(tableColumn.cellElement).data();
    }
  }

  queryRowAsyncData(rowData: any, rowIndex) {
    let kv = {};
    for (let k = 0; k < this.keysArray.length; ++k) {
      let key = this.keysArray[k];
      kv[key] = rowData[key];
    }
    let av = [];
    for (let i = 0; i < this.asyncLoadColumns.length; i++) {
      av.push(this.asyncLoadColumns[i]);
    }
    const columnQueryArgs = [kv, av, this.entity];

    let queryMethodName = this.pageable ? this.paginatedQueryMethod : this.queryMethod;
    if (this.dataService && (queryMethodName in this.dataService) && this.entity) {
      const self = this;
      if (this.asyncLoadSubscriptions[rowIndex]) {
        this.asyncLoadSubscriptions[rowIndex].unsubscribe();
      }
      this.asyncLoadSubscriptions[rowIndex] = this.dataService[queryMethodName].apply(this.dataService, columnQueryArgs).subscribe(res => {
        if (res.code === 0) {
          let data = undefined;
          if (Util.isArray(res.data) && res.data.length === 1) {
            data = res.data[0];
          } else if (Util.isObject(res.data)) {
            data = res.data;
          }
          const cellRowRef = self.table.row(rowIndex);
          var cellRowData = cellRowRef.data();
          Object.assign(cellRowData, data);
          cellRowRef.data(cellRowData);
        }
      });
    }
  }

  public toggleButtonActiveClass(event) {
    if (!event.currentTarget) {
      return;
    }
    let classList = event.currentTarget.classList;
    if (classList.contains(ODataTableComponent.O_DATATABLE_OPTION_ACTIVE_CLASS)) {
      classList.remove(ODataTableComponent.O_DATATABLE_OPTION_ACTIVE_CLASS);
    } else {
      classList.add(ODataTableComponent.O_DATATABLE_OPTION_ACTIVE_CLASS);
    }
  }

  private getAvToInsertFromTableSettings(settings, includeParentKeys: boolean = true) {
    // get av from insert row
    let av = {};
    for (let j = 0; j < settings.aoColumns.length; ++j) {
      let iColDef = settings.aoColumns[j];
      if (iColDef.bVisible && iColDef.editable && (typeof (iColDef.component) !== 'undefined') &&
        (typeof (iColDef.component.editor) !== 'undefined')) {
        let iName = iColDef.name;
        let iValue = iColDef.component.editor.getInsertTableValue();
        if (typeof (iValue) !== 'undefined') {
          av[iName] = iValue;
        }
      }
    }

    // add parent-keys to av
    if (includeParentKeys && (this.dataParentKeys.length > 0) && (typeof (this.parentItem) !== 'undefined')) {
      for (let k = 0; k < this.dataParentKeys.length; ++k) {
        let parentKey = this.dataParentKeys[k];
        if (this.parentItem.hasOwnProperty(parentKey['alias'])) {
          let currentData = this.parentItem[parentKey['alias']];
          if (currentData instanceof OFormValue) {
            currentData = currentData.value;
          }
          av[parentKey['name']] = currentData;
        }
      }
    }
    return av;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-datatable',
  template: `
    <div *ngIf="loading" class="spinner-container" fxFlex="100" fxLayout="row" fxLayoutAlign="center center">
      <md-progress-spinner mode="indeterminate">
      </md-progress-spinner>
    </div>

    <div class="expandable-container fill-remaining">
      <div class="o-table-container" *ngIf="isVisible()" [class.disabled]="oenabled === false" [class.detail]="detailMode !== 'none'"
        title="">

        <table [id]="getAttribute()" [class]="rowHeight"></table>

        <button *ngIf="showOptionsButton" class="o-table-menu-button" md-icon-button [md-menu-trigger-for]="menu">
          <md-icon>more_vert</md-icon>
        </button>

        <md-menu #menu="mdMenu" x-position="before">
          <!--<button *ngIf="exportButton" md-menu-item (click)="exportButtonAction()"> {{ 'TABLE.BUTTONS.EXPORT' | oTranslate }} </button>-->
          <button *ngIf="exportButton || showExportOptions" (click)="exportAction('copyHtml5')" md-menu-item> {{ 'TABLE.BUTTONS.COPY_TO_CLIPBOARD' | oTranslate }} </button>
          <button *ngIf="exportButton || showExportOptions" (click)="exportAction('print')" md-menu-item> {{ 'TABLE.BUTTONS.PRINT' | oTranslate }} </button>
          <!--<button *ngIf="exportButton || showExportOptions" (click)="exportAction('excel')" md-menu-item> {{ 'TABLE.BUTTONS.EXCEL' | oTranslate }} </button>-->
          <button *ngIf="exportButton || showExportOptions" (click)="exportAction('csv')" md-menu-item> {{ 'TABLE.BUTTONS.CSV' | oTranslate }} </button>
          <button *ngIf="exportButton || showExportOptions" (click)="exportAction('pdf')" md-menu-item> {{ 'TABLE.BUTTONS.PDF' | oTranslate }} </button>


          <button *ngIf="columnsGroupButton" md-menu-item (click)="columnsGroupButtonAction($event)"> {{ 'TABLE.BUTTONS.GROUP_ROWS' | oTranslate }} </button>
          <button *ngIf="columnsResizeButton" md-menu-item (click)="columnsResizeButtonAction($event)"> {{ 'TABLE.BUTTONS.RESIZE_COLUMNS' | oTranslate }} </button>
          <button *ngIf="columnsVisibilityButton" md-menu-item (click)="columnsVisibilityButtonAction()"> {{ 'TABLE.BUTTONS.COLVIS' | oTranslate }} </button>

          <button md-menu-item *ngFor="let option of headerOptions" (click)="option.innerOnClick($event)">
            <md-icon *ngIf="option.icon && option.iconPosition === 'before'" class="mat-24">{{ option.icon }}</md-icon>
            {{ option.olabel | oTranslate }}
            <md-icon *ngIf="option.icon && option.iconPosition === 'after'" class="mat-24" style="margin-left: 16px;">{{ option.icon }}</md-icon>
          </button>
        </md-menu>

      </div>
    </div>
  `,
  styles: [`
    .o-table{width:100%;height:100%;position:relative;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;box-sizing:border-box;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}.o-table .spinner-container{position:absolute;top:0px;left:0px;right:0px;bottom:0px;z-index:500;visibility:visible;opacity:1;-moz-transition:opacity 0.25s linear;-webkit-transition:opacity 0.25s linear;transition:opacity 0.25s linear}.o-table .spinner-container path{stroke-width:5px !important}.o-table .o-table-container{display:block;max-width:100%;height:100%;overflow:hidden;position:relative;margin:0 0.5%}.o-table .o-table-container.disabled .dt-buttons{display:none}.o-table .o-table-container.disabled thead tr::before{display:none}.o-table .o-table-container.disabled tbody tr:not(.group)::before{display:none}.o-table .o-table-container.disabled tbody tr.selected::before{display:none}.o-table .o-table-container.disabled tbody tr td.focus{outline:none}.o-table .o-table-container.disabled .dataTables_info .select-info{display:none}.o-table .o-table-container.detail tbody tr:not(.insertRow) td{cursor:pointer}.o-table .o-table-container .dt-buttons{margin:0 10px 0 4px}.o-table .o-table-container .dt-buttons .dt-button{text-decoration:none;outline:none;cursor:pointer;font-size:14px;display:inline-block;margin:0}.o-table .o-table-container .dt-buttons .dt-button:not(.hidden-action-text){padding-right:8px}.o-table .o-table-container .dt-buttons .dt-button:not(.hidden-action-text):not(.disabled):hover{border-radius:4px}.o-table .o-table-container .dt-buttons .dt-button.active::after{border-radius:50%}.o-table .o-table-container .dt-buttons .dt-button.active>span{font-weight:bold}.o-table .o-table-container .dt-buttons .dt-button.disabled{cursor:not-allowed}.o-table .o-table-container .dt-buttons .dt-button.custom-generic-action::after{font-family:'Material Icons';content:attr(data-icon);font-size:24px;line-height:40px;padding:8px;font-feature-settings:'liga'}.o-table .o-table-container .dt-buttons .dt-button.generic-action>span,.o-table .o-table-container .dt-buttons .dt-button.custom-generic-action>span{float:right;line-height:40px}.o-table .o-table-container .dt-buttons .dt-button.generic-action.hidden-action-text>span,.o-table .o-table-container .dt-buttons .dt-button.custom-generic-action.hidden-action-text>span{display:none}.o-table .o-table-container .dt-buttons .dt-button.generic-action.generic-action-export{display:none}.o-table .o-table-container .dt-buttons .dt-button.generic-action.generic-action-export::before{font-family:'Material Icons';content:"file_download";font-size:24px;margin:0px 5px;line-height:40px;padding:5px;font-feature-settings:'liga'}.o-table .o-table-container .dt-buttons .dt-button.generic-action.generic-action-group::before{font-family:'Material Icons';content:"view_list";font-size:24px;margin:0px 5px;line-height:40px;padding:5px;font-feature-settings:'liga'}.o-table .o-table-container .dt-buttons .dt-button.generic-action.generic-action-resize::before{font-family:'Material Icons';content:"compare_arrows";font-size:24px;margin:0px 5px;line-height:40px;padding:5px;font-feature-settings:'liga'}.o-table .o-table-container .dt-buttons .dt-button.generic-action.generic-action-view-column::before{font-family:'Material Icons';content:"view_column";font-size:24px;margin:0px 5px;line-height:40px;padding:5px;font-feature-settings:'liga'}.o-table .o-table-container .dt-buttons .dt-button.generic-action.generic-action-filter::before{font-family:'Material Icons';content:"filter_list";font-size:24px;margin:0px 5px;line-height:40px;padding:5px;font-feature-settings:'liga'}.o-table .o-table-container .dt-buttons .dt-button.generic-action.generic-action-refresh::before{font-family:'Material Icons';content:"autorenew";font-size:24px;line-height:40px;padding:8px;font-feature-settings:'liga'}.o-table .o-table-container .dt-buttons .dt-button.generic-action.generic-action-delete::before{font-family:'Material Icons';content:"delete";font-size:24px;line-height:40px;padding:8px;font-feature-settings:'liga'}.o-table .o-table-container .dt-buttons .dt-button.generic-action.generic-action-add::before{font-family:'Material Icons';content:"add";font-size:24px;line-height:40px;padding:8px;font-feature-settings:'liga'}.o-table .o-table-container .dt-buttons .dt-button.export-action{display:none}.o-table .o-table-container .dt-buttons .dt-button.export-action.buttons-copy>span,.o-table .o-table-container .dt-buttons .dt-button.export-action.buttons-print>span,.o-table .o-table-container .dt-buttons .dt-button.export-action.buttons-pdf>span{display:none}.o-table .o-table-container .dt-buttons .dt-button.export-action.buttons-excel>span,.o-table .o-table-container .dt-buttons .dt-button.export-action.buttons-csv>span{font-weight:bold;margin:0px 5px;vertical-align:6px}.o-table .o-table-container .dt-buttons .dt-button.export-action.buttons-copy::after{font-family:'Material Icons';content:"content_copy";font-size:24px;margin:0px 5px;line-height:40px;padding:5px;font-feature-settings:'liga'}.o-table .o-table-container .dt-buttons .dt-button.export-action.buttons-print::after{font-family:'Material Icons';content:"print";font-size:24px;margin:0px 5px;line-height:40px;padding:5px;font-feature-settings:'liga'}.o-table .o-table-container .dt-buttons .dt-button.export-action.buttons-pdf::after{font-family:'Material Icons';content:"picture_as_pdf";font-size:24px;margin:0px 5px;line-height:40px;padding:5px;font-feature-settings:'liga'}.o-table .o-table-container .dt-buttons .dt-button.buttons-columnVisibility{display:none;float:left;margin:10px 4px 10px 8px;font-size:14px}.o-table .o-table-container .dataTables_hidden_options{width:75%;float:left;text-align:right;display:none}.o-table .o-table-container .dataTables_filter{margin:0px;padding:0px 75px 0 50px;height:40px;min-width:250px;width:25%;float:right;box-sizing:border-box}.o-table .o-table-container .dataTables_filter label{position:relative;vertical-align:top}.o-table .o-table-container .dataTables_filter label::before{font-family:'Material Icons';content:"search";font-size:24px;line-height:40px;width:50px;position:absolute;top:0px;left:-50px;text-align:center;line-height:1;width:30px;top:6px;left:-33px;font-feature-settings:'liga'}.o-table .o-table-container .dataTables_filter input{outline:none;font-size:100%;width:100%;height:24px;margin:7px 0;padding:0px}.o-table .o-table-container .dataTables_filter input:focus{border-bottom-width:2px}.o-table .o-table-container .dataTables_wrapper{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-content:stretch;-ms-flex-line-pack:stretch;align-content:stretch;-webkit-align-items:stretch;-ms-flex-align:stretch;align-items:stretch;margin:0;width:100%;height:100%}.o-table .o-table-container .dataTables_top_wrapper{margin:4px 0px}.o-table .o-table-container .dataTables_top_wrapper{display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-content:center;-ms-flex-line-pack:center;align-content:center;-webkit-align-items:flex-start;-ms-flex-align:start;align-items:flex-start;-webkit-order:0;-ms-flex-order:0;order:0;-webkit-flex:0 1 auto;-ms-flex:0 1 auto;flex:0 1 auto;-webkit-align-self:auto;-ms-flex-item-align:auto;align-self:auto}.o-table .o-table-container .dataTables_top_wrapper .dt-buttons,.o-table .o-table-container .dataTables_top_wrapper .dataTables_options{-webkit-order:0;-ms-flex-order:0;order:0;-webkit-flex:0 1 auto;-ms-flex:0 1 auto;flex:0 1 auto;-webkit-align-self:auto;-ms-flex-item-align:auto;align-self:auto}.o-table .o-table-container .dataTables_top_wrapper .dataTables_filter_wrapper{-webkit-order:0;-ms-flex-order:0;order:0;-webkit-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;-webkit-align-self:auto;-ms-flex-item-align:auto;align-self:auto}.o-table .o-table-container .dataTables_fill_remaining{-webkit-order:0;-ms-flex-order:0;order:0;-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;-webkit-align-self:auto;-ms-flex-item-align:auto;align-self:auto;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;box-sizing:border-box;margin:0;width:100%;height:100%}.o-table .o-table-container .dataTables_fill_remaining .o-table-scroll{overflow:auto;height:100%}.o-table .o-table-container .dataTables_pagination_wrapper{-webkit-order:0;-ms-flex-order:0;order:0;-webkit-flex:0 1 auto;-ms-flex:0 1 auto;flex:0 1 auto;-webkit-align-self:auto;-ms-flex-item-align:auto;align-self:auto}.o-table .o-table-container table{width:100.0%;margin:0;border-spacing:0;overflow:hidden;table-layout:fixed}.o-table .o-table-container table.small thead tr{height:32px}.o-table .o-table-container table.small tbody td .image-avatar{width:20px;height:20px}.o-table .o-table-container table.small tbody tr{height:28px}.o-table .o-table-container table.medium thead tr{height:40px}.o-table .o-table-container table.medium tbody td .image-avatar{width:28px;height:28px}.o-table .o-table-container table.medium tbody tr{height:36px}.o-table .o-table-container table.small .o-table-column.o-table-column-action md-icon,.o-table .o-table-container table.medium .o-table-column.o-table-column-action md-icon{font-size:18px;line-height:22px}.o-table .o-table-container table.large thead tr{height:52px}.o-table .o-table-container table.large tbody tr{height:48px}.o-table .o-table-container table thead tr{height:56px}.o-table .o-table-container table thead tr th{position:relative;font-size:14px;font-weight:700;vertical-align:middle;text-align:center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:42px;outline:none}.o-table .o-table-container table thead tr th:last-child:not(.o-table-column-action){padding:0 42px 0 24px !important}.o-table .o-table-container table thead tr th:first-child:not(.o-table-column-select-checkbox){padding:0 24px 0 24px !important}.o-table .o-table-container table thead tr th:first-child.o-table-column-select-checkbox{padding:0 12px 0 12px !important}.o-table .o-table-container table thead tr th:nth-child(2){padding:0 42px 0 24px !important}.o-table .o-table-container table thead tr th:nth-child(n+3):nth-last-child(n+2):not(.o-table-column-action){padding:0 42px 0 24px !important}.o-table .o-table-container table thead tr th.o-table-select-checkbox{width:20px;padding:0 0 0 24px}.o-table .o-table-container table thead tr th.sorting,.o-table .o-table-container table thead tr th.sorting_asc,.o-table .o-table-container table thead tr th.sorting_desc{cursor:pointer}.o-table .o-table-container table thead tr th.sorting::before,.o-table .o-table-container table thead tr th.sorting_asc::before,.o-table .o-table-container table thead tr th.sorting_desc::before,.o-table .o-table-container table thead tr th.sorting_asc_disabled::before,.o-table .o-table-container table thead tr th.sorting_desc_disabled::before{right:20px;font-family:'Material Icons';content:"arrow_upward";position:absolute;display:block;font-size:16px;font-weight:normal;font-feature-settings:'liga'}.o-table .o-table-container table thead tr th.sorting::after,.o-table .o-table-container table thead tr th.sorting_asc::after,.o-table .o-table-container table thead tr th.sorting_desc::after,.o-table .o-table-container table thead tr th.sorting_asc_disabled::after,.o-table .o-table-container table thead tr th.sorting_desc_disabled::after{right:8px;font-family:'Material Icons';content:"arrow_downward";position:absolute;font-size:16px;font-weight:normal;font-feature-settings:'liga'}.o-table .o-table-container table thead tr th.sorting_disabled::before,.o-table .o-table-container table thead tr th.sorting_disabled::after{opacity:0.5}.o-table .o-table-container table thead tr th div.sorting-index{position:absolute;top:28px;right:2px;font-weight:normal;font-size:10px}.o-table .o-table-container table thead tr th.group{text-decoration:underline}.o-table .o-table-container table thead tr th.o-table-column-action{padding:0 18px 0 18px !important;box-sizing:border-box}.o-table .o-table-container table thead tr th.o-table-column-action:last-child{padding-right:24px !important}.o-table .o-table-container table tbody tr{transition:background-color .2s;height:48px}.o-table .o-table-container table tbody tr.empty{height:0px !important}.o-table .o-table-container table tbody tr.group td{font-weight:bold}.o-table .o-table-container table tbody tr.group td:last-child{padding:0 16px !important}.o-table .o-table-container table tbody tr.group td .image-avatar{margin:0px}.o-table .o-table-container table tbody tr.group+tr td{border:none}.o-table .o-table-container table tbody tr.editRow input:not([type="checkbox"]){top:3px;left:3px;bottom:3px;height:auto;width:90%}.o-table .o-table-container table tbody tr.editRow select{top:3px;left:3px;bottom:3px;height:auto;width:98%}.o-table .o-table-container table tbody tr.insertRow td input:not([type="checkbox"]){top:3px;left:3px;bottom:3px;height:auto}.o-table .o-table-container table tbody tr.insertRow td select{top:3px;left:3px;bottom:3px;height:auto;width:98%}.o-table .o-table-container table tbody td{vertical-align:middle;text-align:left;font-size:13px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;position:relative;cursor:default}.o-table .o-table-container table tbody td.o-table-column-centered{text-align:center}.o-table .o-table-container table tbody td.focus{outline-offset:-1px}.o-table .o-table-container table tbody td.editable{cursor:text;cursor:cell}.o-table .o-table-container table tbody td.editing{outline-offset:-1px}.o-table .o-table-container table tbody td input{position:absolute;top:2px;left:2px;width:100%;height:100%;padding:0px 10px;border:none;outline:none}.o-table .o-table-container table tbody td select{position:absolute;top:-1px;left:1px;width:98%;height:100%;padding:0px 5px 0px 10px;border:none;outline:none}.o-table .o-table-container table tbody td input[type="checkbox"]{height:14px;padding:0px;margin-left:0px}.o-table .o-table-container table tbody td:last-child:not(.o-table-column-action){padding:0 42px 0 24px !important}.o-table .o-table-container table tbody td:first-child:not(.o-table-column-action):not(.o-table-column-select-checkbox){padding:0 7px 0 7px !important}.o-table .o-table-container table tbody td:nth-child(2):not(.o-table-column-action){padding:0 42px 0 24px !important}.o-table .o-table-container table tbody td:nth-child(n+3):nth-last-child(n+2):not(.o-table-column-action){padding:0 42px 0 24px !important}.o-table .o-table-container table tbody td>div{max-height:48px}.o-table .o-table-container table tbody td.dataTables_empty{text-align:center;border-bottom-width:0px !important}.o-table .o-table-container table tbody td.o-table-column-boolean{text-align:center}.o-table .o-table-container table tbody td.o-table-column-string{text-align:left}.o-table .o-table-container table tbody td.o-table-column-number{text-align:right}.o-table .o-table-container table tbody td.o-table-column-date{text-align:center}.o-table .o-table-container table tbody td.o-table-column-image{text-align:center}.o-table .o-table-container table tbody td.o-table-column-action{text-align:center;padding:0px !important}.o-table .o-table-container table tbody td.o-table-column-action.focus{outline:none}.o-table .o-table-container table tbody td.o-table-column-action .o-table-row-action{text-transform:uppercase;text-decoration:underline;line-height:1;width:100%;cursor:pointer}.o-table .o-table-container table tbody td.o-table-column-action .o-table-row-action-edit-cancel,.o-table .o-table-container table tbody td.o-table-column-action .o-table-row-action-edit-save{width:50%;font-weight:bold;font-size:26px;cursor:pointer}.o-table .o-table-container table tbody td .image-plain{height:30px}.o-table .o-table-container table tbody td .image-plain img{max-width:100%;height:100%}.o-table .o-table-container table tbody td .image-avatar{width:34px;height:34px;margin:1px auto;overflow:hidden;border-radius:50%;position:relative;z-index:1}.o-table .o-table-container table tbody td .image-avatar img{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%, -50%);-moz-transform:translate(-50%, -50%);-ms-transform:translate(-50%, -50%);-o-transform:translate(-50%, -50%);transform:translate(-50%, -50%);width:100%;max-width:inherit;max-height:inherit}.o-table .o-table-container .noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.o-table .o-table-container .dataTables_length{float:right;margin:10px 10px 10px 0px;font-size:14px;line-height:22px}.o-table .o-table-container .dataTables_length select{border:none;margin-left:10px;outline:none}.o-table .o-table-container .dataTables_info{float:right;margin:10px 10px 10px 0px;font-size:14px;line-height:24px}.o-table .o-table-container .dataTables_info .select-info{position:absolute;left:20px;bottom:21px}.o-table .o-table-container .dataTables_paginate{float:right;margin:10px 10px 10px 0px;font-size:0px}.o-table .o-table-container .dataTables_paginate .paginate_button{visibility:hidden;cursor:pointer}.o-table .o-table-container .dataTables_paginate .paginate_button.first::after{font-family:'Material Icons';content:"first_page";visibility:visible;font-size:24px;margin:0px 5px;font-feature-settings:'liga'}.o-table .o-table-container .dataTables_paginate .paginate_button.previous::after{font-family:'Material Icons';content:"keyboard_arrow_left";visibility:visible;font-size:24px;margin:0px 5px;font-feature-settings:'liga'}.o-table .o-table-container .dataTables_paginate .paginate_button.next::after{font-family:'Material Icons';content:"keyboard_arrow_right";visibility:visible;font-size:24px;margin:0px 5px;font-feature-settings:'liga'}.o-table .o-table-container .dataTables_paginate .paginate_button.last::after{font-family:'Material Icons';content:"last_page";visibility:visible;font-size:24px;margin:0px 5px;font-feature-settings:'liga'}.o-table .o-table-container .dataTables_paginate .paginate_button.disabled{cursor:not-allowed}.o-table .o-table-menu-button{position:absolute;top:4px;right:0px}.o-table .o-table-menu-button .material-icons{top:7px;position:absolute;left:0;width:100%}div.dt-button-collection{position:absolute;top:0;left:0;min-width:200px;margin-top:3px;padding:12px 12px 8px 12px;border-radius:4px !important;box-shadow:0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12);z-index:2002;-webkit-column-gap:8px;-moz-column-gap:8px;-ms-column-gap:8px;-o-column-gap:8px;column-gap:8px;overflow-y:auto;max-height:60%}div.dt-button-collection button.dt-button,div.dt-button-collection div.dt-button,div.dt-button-collection a.dt-button{position:relative;left:0;right:0;display:block;float:none;margin-bottom:8px;margin-right:0;text-decoration:none;line-height:34px;min-height:34px;font-size:14px;padding:0px 10px 0px 34px;outline:none}div.dt-button-collection a.dt-button:hover{border-radius:4px}div.dt-button-collection button.dt-button::before,div.dt-button-collection div.dt-button::before,div.dt-button-collection a.dt-button::before{font-family:'Material Icons';content:"check_box_outline_blank";font-size:18px;line-height:34px;position:absolute;left:8px;font-feature-settings:'liga'}div.dt-button-collection button.dt-button:active:not(.disabled),div.dt-button-collection button.dt-button.active:not(.disabled),div.dt-button-collection div.dt-button:active:not(.disabled),div.dt-button-collection div.dt-button.active:not(.disabled),div.dt-button-collection a.dt-button:active:not(.disabled),div.dt-button-collection a.dt-button.active:not(.disabled){font-weight:bold}div.dt-button-collection button.dt-button:active:not(.disabled),div.dt-button-collection button.dt-button.active:not(.disabled)::before,div.dt-button-collection div.dt-button:active:not(.disabled)::before,div.dt-button-collection div.dt-button.active:not(.disabled)::before,div.dt-button-collection a.dt-button:active:not(.disabled)::before,div.dt-button-collection a.dt-button.active:not(.disabled)::before{font-family:'Material Icons';content:"check_box";font-size:18px;line-height:34px;position:absolute;left:8px;font-feature-settings:'liga'}div.dt-button-collection.fixed{position:fixed;top:50%;left:50%;margin-left:-75px;border-radius:0}div.dt-button-collection.fixed.two-column{margin-left:-150px}div.dt-button-collection.fixed.three-column{margin-left:-225px}div.dt-button-collection.fixed.four-column{margin-left:-300px}div.dt-button-collection>*{-webkit-column-break-inside:avoid;break-inside:avoid}div.dt-button-collection.two-column{width:300px;padding-bottom:1px;-webkit-column-count:2;-moz-column-count:2;-ms-column-count:2;-o-column-count:2;column-count:2}div.dt-button-collection.three-column{width:450px;padding-bottom:1px;-webkit-column-count:3;-moz-column-count:3;-ms-column-count:3;-o-column-count:3;column-count:3}div.dt-button-collection.four-column{width:600px;padding-bottom:1px;-webkit-column-count:4;-moz-column-count:4;-ms-column-count:4;-o-column-count:4;column-count:4}div.dt-button-background{position:fixed;top:0;left:0;width:100%;height:100%;z-index:2001}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox::before,.o-table .o-table-container table thead tr th.o-table-column-select-checkbox::after{content:initial !important}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox,.o-table .o-table-container table tbody td.o-table-column-select-checkbox{text-align:center}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.focus,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.focus{outline:none}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox input[type="checkbox"].select-row,.o-table .o-table-container table tbody td.o-table-column-select-checkbox input[type="checkbox"].select-row{height:14px;width:14px;padding:0px;margin-left:0px;margin:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;position:absolute;top:2px;left:2px}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-checked .mat-checkbox-inner-container .mat-checkbox-checkmark-path,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-checked .mat-checkbox-inner-container .mat-checkbox-checkmark-path{stroke-dashoffset:0}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-checked .mat-checkbox-inner-container .mat-checkbox-mixedmark,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-checked .mat-checkbox-inner-container .mat-checkbox-mixedmark{transform:scaleX(1) rotate(-45deg)}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-checked .mat-checkbox-inner-container .mat-checkbox-checkmark,.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-checked .mat-checkbox-inner-container .mat-checkbox-background,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-checked .mat-checkbox-inner-container .mat-checkbox-checkmark,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-checked .mat-checkbox-inner-container .mat-checkbox-background{opacity:1}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-indeterminate .mat-checkbox-inner-container .mat-checkbox-background,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-indeterminate .mat-checkbox-inner-container .mat-checkbox-background{opacity:1}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-indeterminate .mat-checkbox-inner-container .mat-checkbox-checkmark,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-indeterminate .mat-checkbox-inner-container .mat-checkbox-checkmark{opacity:0;transform:rotate(45deg)}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-indeterminate .mat-checkbox-inner-container .mat-checkbox-checkmark-path,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-indeterminate .mat-checkbox-inner-container .mat-checkbox-checkmark-path{stroke-dashoffset:0}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-indeterminate .mat-checkbox-inner-container .mat-checkbox-mixedmark,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-indeterminate .mat-checkbox-inner-container .mat-checkbox-mixedmark{opacity:1;transform:scaleX(1) rotate(0deg)}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox .mat-checkbox-inner-container,.o-table .o-table-container table tbody td.o-table-column-select-checkbox .mat-checkbox-inner-container{display:inline-block;height:18px;line-height:0;margin:auto;order:0;position:relative;vertical-align:middle;white-space:nowrap;width:18px;cursor:pointer}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-frame,.o-table .o-table-container table thead tr th.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-background,.o-table .o-table-container table thead tr th.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-checkmark,.o-table .o-table-container table tbody td.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-frame,.o-table .o-table-container table tbody td.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-background,.o-table .o-table-container table tbody td.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-checkmark{bottom:0;left:0;position:absolute;right:0;top:0}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-frame,.o-table .o-table-container table thead tr th.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-background,.o-table .o-table-container table tbody td.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-frame,.o-table .o-table-container table tbody td.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-background{border-radius:2px;box-sizing:border-box;pointer-events:none}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-frame,.o-table .o-table-container table tbody td.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-frame{transition:border-color 140ms cubic-bezier(0, 0, 0.2, 0.1);will-change:border-color}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-background,.o-table .o-table-container table tbody td.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-background{align-items:center;opacity:0;display:inline-flex;justify-content:center;transition:background-color 140ms cubic-bezier(0, 0, 0.2, 0.1),opacity 140ms cubic-bezier(0, 0, 0.2, 0.1);will-change:background-color, opacity}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-checkmark,.o-table .o-table-container table thead tr th.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-mixedmark,.o-table .o-table-container table tbody td.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-checkmark,.o-table .o-table-container table tbody td.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-mixedmark{width:calc(100% - 4px)}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-checkmark,.o-table .o-table-container table tbody td.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-checkmark{width:100%}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-mixedmark,.o-table .o-table-container table tbody td.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-mixedmark{height:2.4px;opacity:0;transform:scaleX(0) rotate(0deg)}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-checkmark-path,.o-table .o-table-container table tbody td.o-table-column-select-checkbox .mat-checkbox-inner-container .mat-checkbox-checkmark-path{stroke-dashoffset:22.91026;stroke-dasharray:22.91026;stroke-width:2.4px}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-anim-unchecked-checked .mat-checkbox-background,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-anim-unchecked-checked .mat-checkbox-background{animation:280ms linear 0s mat-checkbox-fade-in-background}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-anim-unchecked-checked .mat-checkbox-checkmark-path,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-anim-unchecked-checked .mat-checkbox-checkmark-path{animation:280ms linear 0s mat-checkbox-unchecked-checked-checkmark-path}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-anim-unchecked-indeterminate .mat-checkbox-background,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-anim-unchecked-indeterminate .mat-checkbox-background{animation:280ms linear 0s mat-checkbox-fade-in-background}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-anim-unchecked-indeterminate .mat-checkbox-mixedmark,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-anim-unchecked-indeterminate .mat-checkbox-mixedmark{animation:140ms linear 0s mat-checkbox-unchecked-indeterminate-mixedmark}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-anim-checked-unchecked .mat-checkbox-background,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-anim-checked-unchecked .mat-checkbox-background{animation:280ms linear 0s mat-checkbox-fade-out-background}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-anim-checked-unchecked .mat-checkbox-checkmark-path,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-anim-checked-unchecked .mat-checkbox-checkmark-path{animation:140ms linear 0s mat-checkbox-checked-unchecked-checkmark-path}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-anim-checked-indeterminate .mat-checkbox-checkmark .mat-checkbox-checkmark,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-anim-checked-indeterminate .mat-checkbox-checkmark .mat-checkbox-checkmark{animation:140ms linear 0s mat-checkbox-checked-indeterminate-checkmark}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-anim-checked-indeterminate .mat-checkbox-checkmark .mat-checkbox-mixedmark,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-anim-checked-indeterminate .mat-checkbox-checkmark .mat-checkbox-mixedmark{animation:140ms linear 0s mat-checkbox-checked-indeterminate-mixedmark}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-anim-indeterminate-checked .mat-checkbox-checkmark,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-anim-indeterminate-checked .mat-checkbox-checkmark{animation:500ms linear 0s mat-checkbox-indeterminate-checked-checkmark}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-anim-indeterminate-checked .mat-checkbox-mixedmark,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-anim-indeterminate-checked .mat-checkbox-mixedmark{animation:500ms linear 0s mat-checkbox-indeterminate-checked-mixedmark}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-anim-indeterminate-unchecked .mat-checkbox-background,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-anim-indeterminate-unchecked .mat-checkbox-background{animation:280ms linear 0s mat-checkbox-fade-out-background}.o-table .o-table-container table thead tr th.o-table-column-select-checkbox.mat-checkbox-anim-indeterminate-unchecked .mat-checkbox-mixedmark,.o-table .o-table-container table tbody td.o-table-column-select-checkbox.mat-checkbox-anim-indeterminate-unchecked .mat-checkbox-mixedmark{animation:300ms linear 0s mat-checkbox-indeterminate-unchecked-mixedmark}@keyframes mat-checkbox-fade-in-background{0%{opacity:0}50%{opacity:1}}@keyframes mat-checkbox-fade-out-background{0%,50%{opacity:1}100%{opacity:0}}@keyframes mat-checkbox-unchecked-checked-checkmark-path{0%,50%{stroke-dashoffset:22.91026}50%{animation-timing-function:cubic-bezier(0, 0, 0.2, 0.1)}100%{stroke-dashoffset:0}}@keyframes mat-checkbox-unchecked-indeterminate-mixedmark{0%,68.2%{transform:scaleX(0)}68.2%{animation-timing-function:cubic-bezier(0, 0, 0, 1)}100%{transform:scaleX(1)}}@keyframes mat-checkbox-checked-unchecked-checkmark-path{from{animation-timing-function:cubic-bezier(0.4, 0, 1, 1);stroke-dashoffset:0}to{stroke-dashoffset:-22.91026}}@keyframes mat-checkbox-checked-indeterminate-checkmark{from{animation-timing-function:cubic-bezier(0, 0, 0.2, 0.1);opacity:1;transform:rotate(0deg)}to{opacity:0;transform:rotate(45deg)}}@keyframes mat-checkbox-indeterminate-checked-checkmark{from{animation-timing-function:cubic-bezier(0.14, 0, 0, 1);opacity:0;transform:rotate(45deg)}to{opacity:1;transform:rotate(360deg)}}@keyframes mat-checkbox-checked-indeterminate-mixedmark{from{animation-timing-function:cubic-bezier(0, 0, 0.2, 0.1);opacity:0;transform:rotate(-45deg)}to{opacity:1;transform:rotate(0deg)}}@keyframes mat-checkbox-indeterminate-checked-mixedmark{from{animation-timing-function:cubic-bezier(0.14, 0, 0, 1);opacity:1;transform:rotate(0deg)}to{opacity:0;transform:rotate(315deg)}}@keyframes mat-checkbox-indeterminate-unchecked-mixedmark{0%{animation-timing-function:linear;opacity:1;transform:scaleX(1)}32.8%,100%{opacity:0;transform:scaleX(0)}}.o-table table.fixedHeader-floating{position:fixed !important;z-index:200;left:initial !important}.o-table table.fixedHeader-floating.no-footer{border-bottom-width:0}.o-table table.fixedHeader-locked{position:absolute !important;z-index:200}@media print{table.fixedHeader-floating{display:none}}
  `],
  providers: [
    { provide: OntimizeService, useFactory: dataServiceFactory, deps: [Injector] }
  ],
  inputs: DEFAULT_INPUTS_O_DATATABLE,
  outputs: DEFAULT_OUTPUTS_O_DATATABLE,
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class.o-table]': 'true',
    '[class.o-datatable]': 'true',
    '[class.ontimize-table]': 'true'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Injector, },
{type: ElementRef, },
{type: OFormComponent, decorators: [{ type: Optional }, { type: Inject, args: [forwardRef(() => OFormComponent), ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'menuTrigger': [{ type: ViewChild, args: [MdMenuTrigger, ] },],
};
}


export class ODataTableComponentModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    ODataTableComponent,
    ODataTableColumnComponent,
    ODataTableCellRendererActionComponent,
    ODataTableCellRendererBooleanComponent,
    ODataTableCellRendererCurrencyComponent,
    ODataTableCellRendererDateComponent,
    ODataTableCellRendererImageComponent,
    ODataTableCellRendererIntegerComponent,
    ODataTableCellRendererRealComponent,
    ODataTableCellRendererServiceComponent,
    ODataTableCellRendererStringComponent,
    ODataTableCellEditorBooleanComponent,
    ODataTableCellEditorComboComponent,
    ODataTableCellEditorDateComponent,
    ODataTableCellEditorIntegerComponent,
    ODataTableCellEditorRealComponent,
    ODataTableCellEditorStringComponent,
    ODataTableButtonComponent,
    ODataTableOptionComponent,
    ODataTableCellEditorDateDialog
  ],
  imports: [
    OSharedModule,
    CommonModule,
    ODateInputModule,
    OFormModule,
    RouterModule
  ],
  entryComponents: [ODataTableCellEditorDateDialog],
  exports: [
    ODataTableComponent,
    ODataTableColumnComponent,
    ODataTableCellRendererActionComponent,
    ODataTableCellRendererBooleanComponent,
    ODataTableCellRendererCurrencyComponent,
    ODataTableCellRendererDateComponent,
    ODataTableCellRendererImageComponent,
    ODataTableCellRendererIntegerComponent,
    ODataTableCellRendererRealComponent,
    ODataTableCellRendererServiceComponent,
    ODataTableCellRendererStringComponent,
    ODataTableCellEditorBooleanComponent,
    ODataTableCellEditorComboComponent,
    ODataTableCellEditorDateComponent,
    ODataTableCellEditorIntegerComponent,
    ODataTableCellEditorRealComponent,
    ODataTableCellEditorStringComponent,
    ODataTableButtonComponent,
    ODataTableOptionComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
